import React, { useState, useEffect } from 'react';
import '../scss/Emsmain.scss';
import { useNavigate, useLocation } from 'react-router-dom';
import Header from '../components/header'
import BaseURL from '../assets/contants/BaseURL';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from 'axios';
import ExcelJS from 'exceljs';
import {
    BarChart, Bar, ComposedChart, Line,
    XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer
} from 'recharts';

const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];

const ProductionSub = () => {
    const location = useLocation();
    const { machineId, machine_id, machineName } = location.state || {};
    // const [machinesData, setMachinesData] = useState([]);
    const navigate = useNavigate();
    const [chartData, setChartData] = useState({
        categories: [],
        chartData: []
    });
    const [selectedNewYear, setSelectedNewYear] = useState(new Date().getFullYear());
    const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [monthlyData, setMonthlyData] = useState({
        categories: monthNames,
        kWh: Array(12).fill(0),
        cost: Array(12).fill(0),
        co2: Array(12).fill(0),
        production: {},
        production_per_kWh: {},
        target_production: {},
        entries: Array(12).fill(0),
    });
    // const modalRef = useRef();
    const [summaryData, setSummaryData] = useState(null);
    const [products, setProducts] = useState([]);
    const [machineTargets, setMachineTargets] = useState({});
    const [machineConfig, setMachineConfig] = useState({
        diesel: false,
        lpg: false,
        target_diesel: 0,
        target_lpg: 0
    });
    // const [isSuperuser, setIsSuperuser] = useState(false);

    // useEffect(() => {
    //     const superuserStatus = sessionStorage.getItem('superuser') === 'true';
    //     setIsSuperuser(superuserStatus);
    // }, []);

    const [visibleSeries, setVisibleSeries] = useState(() => {
        const initialVisible = {
            cost: true,
            kWh: true,
            calculated_diesel_kwh: true,
            calculated_lpg_kwh: true,
            calculated_total_kwh: true
        };

        if (products.length > 0) {
            products.forEach(product => {
                const productKey = product.product_name.toLowerCase();
                initialVisible[productKey] = true;
                initialVisible[`kwh_per_${productKey}`] = true;
                initialVisible[`target_${productKey}`] = true;

                initialVisible[`diesel_per_${productKey}`] = true;
                initialVisible[`lpg_per_${productKey}`] = true;
            });
        }

        if (machineConfig?.diesel) {
            initialVisible['diesel'] = true;
            initialVisible['diesel_target'] = true;
            initialVisible['diesel_cost'] = true;
        }
        if (machineConfig?.lpg) {
            initialVisible['lpg'] = true;
            initialVisible['lpg_target'] = true;
            initialVisible['lpg_cost'] = true;
        }

        return initialVisible;
    });

    useEffect(() => {
        if (products.length > 0) {
            setVisibleSeries(prev => {
                const newVisible = { ...prev };
                products.forEach(product => {
                    const productKey = product.product_name.toLowerCase();
                    if (newVisible[productKey] === undefined) {
                        newVisible[productKey] = true;
                        newVisible[`kwh_per_${productKey}`] = true;
                        newVisible[`target_${productKey}`] = true;
                        newVisible[`diesel_per_${productKey}`] = true;
                        newVisible[`lpg_per_${productKey}`] = true;
                    }
                });

                if (machineConfig?.diesel) {
                    newVisible['diesel'] = newVisible['diesel'] !== undefined ? newVisible['diesel'] : true;
                    newVisible['diesel_target'] = newVisible['diesel_target'] !== undefined ? newVisible['diesel_target'] : true;
                }
                if (machineConfig?.lpg) {
                    newVisible['lpg'] = newVisible['lpg'] !== undefined ? newVisible['lpg'] : true;
                    newVisible['lpg_target'] = newVisible['lpg_target'] !== undefined ? newVisible['lpg_target'] : true;
                }

                return newVisible;
            });
        }
    }, [products, machineConfig]);

    const toggleSeries = (seriesName) => {
        setVisibleSeries(prev => ({
            ...prev,
            [seriesName]: !prev[seriesName]
        }));
    };


    const chartDataRecharts = chartData.chartData.map((entry, index) => {
        const result = { date: entry.date };
        const isToday = new Date(entry.date).toDateString() === new Date().toDateString();
        result.calculated_diesel_kwh = entry.calculated_diesel_kwh || 0;
        result.calculated_lpg_kwh = entry.calculated_lpg_kwh || 0;
        result.calculated_total_kwh = entry.calculated_total_kwh || 0;

        if (entry.production) {
            Object.entries(entry.production).forEach(([product, value]) => {
                const productKey = product.toLowerCase();
                result[productKey] = value;
                const targetKey = `target_${productKey}`;

                if (isToday || entry.target?.[product] === 0 || entry.target?.[product] === null) {
                    result[targetKey] = machineTargets[product] !== undefined 
                        ? parseFloat(machineTargets[product]) 
                        : null;
                } 

                else if (entry.target?.[product] !== undefined) {
                    result[targetKey] = parseFloat(entry.target[product]);
                }
                else {
                    result[targetKey] = machineTargets[product] !== undefined 
                        ? parseFloat(machineTargets[product]) 
                        : null;
                }

                result[`diesel_per_${productKey}`] = entry.energy?.Diesel?.per_product?.[product] || 0;
                result[`lpg_per_${productKey}`] = entry.energy?.LPG?.per_product?.[product] || 0;
            });
        }

        products.forEach(product => {
            const productKey = product.product_name.toLowerCase();
            const energyKey = `kwh_per_${productKey}`;
            if (entry[energyKey] !== undefined) {
                result[energyKey] = entry[energyKey];
            }
        });

        if (entry.energy) {
            if (entry.energy.Diesel) {
                result['diesel'] = entry.energy.Diesel.value;
                if (isToday || entry.energy.Diesel.target_value === 0 || entry.energy.Diesel.target_value === null) {
                    result['diesel_target'] = machineConfig?.target_diesel ?? null;
                }
                else if (entry.energy.Diesel.target_value !== undefined) {
                    result['diesel_target'] = entry.energy.Diesel.target_value;
                }
                else {
                    result['diesel_target'] = machineConfig?.target_diesel ?? null;
                }
            }
            if (entry.energy.LPG) {
                result['lpg'] = entry.energy.LPG.value;
                if (isToday || entry.energy.LPG.target_value === 0 || entry.energy.LPG.target_value === null) {
                    result['lpg_target'] = machineConfig?.target_lpg ?? null;
                }
                else if (entry.energy.LPG.target_value !== undefined) {
                    result['lpg_target'] = entry.energy.LPG.target_value;
                }
                else {
                    result['lpg_target'] = machineConfig?.target_lpg ?? null;
                }
            }
        }

        result.kWh = entry.kWh || 0;
        result.cost = entry.cost || 0;
        result.co2 = entry.co2 || 0;
        result.entries = entry.entries || 0;
        result.from_date_time = entry.from_date_time;
        result.to_date_time = entry.to_date_time;

        Object.keys(result).forEach(key => {
            if (visibleSeries[key] === false) {
                result[key] = null;
            }
        });

        return result;
    });

    const syncId = "chart";
    const margin = { top: 10, right: 30, left: 0, bottom: 0 };
    const xAxisProps = {
        dataKey: "date",
        tick: {
            fontSize: 11,
            angle: -45,
            textAnchor: 'end',
        },
        tickMargin: 10,
        interval: 0,
        height: 60,
        allowDuplicatedCategory: true,
        tickFormatter: (value) => {
            const day = new Date(value).getDate();
            return isNaN(day) ? value.split('-')[2] || value : day;
        },
    };
    const yAxisProps = {
        width: 60,
        tick: { fontSize: 11, fontFamily: 'monospace' },
        tickFormatter: (val) => val === null ? '' : val.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }),
    };

    const tooltipProps = {
        content: ({ active, payload, label }) => {
            if (!active || !payload || !payload.length) return null;

            const entry = chartData.chartData.find(item => item.date === label);
            const fromTime = entry?.from_date_time || '';
            const toTime = entry?.to_date_time || '';
            const productUnits = {};
            products.forEach(product => {
                productUnits[product.product_name.toLowerCase()] = product.weight_unit;
            });

            const dieselTarget = payload.find(item => item.dataKey === 'diesel_target')?.value;
            const lpgTarget = payload.find(item => item.dataKey === 'lpg_target')?.value;

            return (
                <div style={{
                    backgroundColor: 'rgba(150, 150, 150, 0.4)',
                    padding: '4px',
                    border: '1px solid rgba(0, 0, 0, 0.1)',
                    borderRadius: '3px',
                    fontSize: '12px',
                    minWidth: '120px',
                    backdropFilter: 'blur(3px)'
                }}>
                    <div style={{
                        margin: 0,
                        padding: '3px',
                        backgroundColor: 'rgba(211, 211, 211, 0.7)',
                        borderRadius: '3px',
                        marginBottom: '3px',
                        textAlign: 'center',
                        fontSize: '0.9em'
                    }}>
                        <strong>{label}</strong>
                        {fromTime && toTime && (
                            <div style={{ fontSize: '0.7em', color: '#666' }}>
                                {fromTime} to {toTime}
                            </div>
                        )}
                    </div>

                    {payload
                        .filter(item => !['diesel_target', 'lpg_target'].includes(item.dataKey))
                        .map((entry, index) => {
                            let unit = '';
                            const dataKey = entry.dataKey.toLowerCase();

                            if (dataKey === 'kwh') unit = ' kWh';
                            else if (dataKey === 'cost') unit = ' Rs';
                            else if (dataKey === 'diesel') unit = ' L';
                            else if (dataKey === 'lpg') unit = ' kg';
                            else if (dataKey === 'calculated_diesel_kwh') unit = ' kWh';
                            else if (dataKey === 'calculated_lpg_kwh') unit = ' kWh';
                            else if (dataKey === 'calculated_total_kwh') unit = ' kWh';
                            else if (dataKey.startsWith('diesel_per_')) {
                                const productKey = dataKey.replace('diesel_per_', '');
                                unit = ` L/${productUnits[productKey] || 'unit'}`;
                            }
                            else if (dataKey.startsWith('lpg_per_')) {
                                const productKey = dataKey.replace('lpg_per_', '');
                                unit = ` kg/${productUnits[productKey] || 'unit'}`;
                            }
                            else if (dataKey.startsWith('kwh_per_')) {
                                const productKey = dataKey.replace('kwh_per_', '');
                                unit = ` kWh/${productUnits[productKey] || 'unit'}`;
                            }
                            else if (dataKey.includes('target_')) {
                                const productKey = dataKey.replace('target_', '');
                                unit = ` kWh/${productUnits[productKey] || 'unit'}`;
                            }
                            else {
                                unit = ` ${productUnits[dataKey] || 'unit'}`;
                            }

                            return (
                                <div key={`item-${index}`} style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    margin: '2px 0'
                                }}>
                                    <span style={{
                                        display: 'inline-block',
                                        width: '8px',
                                        height: '8px',
                                        borderRadius: '50%',
                                        backgroundColor: entry.color || '#000',
                                        marginRight: '5px',
                                        flexShrink: 0
                                    }} />
                                    <span style={{ marginRight: '3px', fontSize: '0.9em' }}>{entry.name}:</span>
                                    <strong style={{ fontSize: '0.9em' }}>
                                        {entry.value === null ? 'N/A' : entry.value.toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        })}
                                        {entry.value !== null && unit}
                                    </strong>
                                </div>
                            );
                        })
                    }

                    {dieselTarget !== undefined && products.map((product, idx) => {
                        const productKey = product.product_name.toLowerCase();
                        const unit = productUnits[productKey] || 'unit';
                        return (
                            <div key={`diesel-target-${idx}`} style={{
                                display: 'flex',
                                alignItems: 'center',
                                margin: '2px 0'
                            }}>
                                <span style={{
                                    display: 'inline-block',
                                    width: '8px',
                                    height: '8px',
                                    borderRadius: '50%',
                                    backgroundColor: getTargetColor(),
                                    marginRight: '5px',
                                    flexShrink: 0
                                }} />
                                <span style={{ marginRight: '3px', fontSize: '0.9em' }}>
                                    Diesel {product.product_name} Target:
                                </span>
                                <strong style={{ fontSize: '0.9em' }}>
                                    {dieselTarget.toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    })}
                                    {` L/${unit}`}
                                </strong>
                            </div>
                        );
                    })}

                    {lpgTarget !== undefined && products.map((product, idx) => {
                        const productKey = product.product_name.toLowerCase();
                        const unit = productUnits[productKey] || 'unit';
                        return (
                            <div key={`lpg-target-${idx}`} style={{
                                display: 'flex',
                                alignItems: 'center',
                                margin: '2px 0'
                            }}>
                                <span style={{
                                    display: 'inline-block',
                                    width: '8px',
                                    height: '8px',
                                    borderRadius: '50%',
                                    backgroundColor: getTargetColor(),
                                    marginRight: '5px',
                                    flexShrink: 0
                                }} />
                                <span style={{ marginRight: '3px', fontSize: '0.9em' }}>
                                    LPG {product.product_name} Target:
                                </span>
                                <strong style={{ fontSize: '0.9em' }}>
                                    {lpgTarget.toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    })}
                                    {` kg/${unit}`}
                                </strong>
                            </div>
                        );
                    })}
                </div>
            );
        },
        contentStyle: {
            backgroundColor: 'transparent',
            border: 'none',
            padding: 0,
            margin: 0
        },
        wrapperStyle: {
            backgroundColor: 'transparent',
            boxShadow: 'none'
        }
    };

    const getCommonUnit = (products) => {
        const units = [...new Set(products.map(p => p.weight_unit))];
        return units.length === 1 ? units[0] : units.join(' / ');
    };

    const [monthSeries, setMonthSeries] = useState({
        cost: true,
        kWh: true,
    });

    const initializeSeriesState = (data) => {
        if (data.monthly_data && data.monthly_data.length > 0) {
            const firstMonth = data.monthly_data[0];
            const newSeries = { ...monthSeries };

            Object.keys(firstMonth.production || {}).forEach(product => {
                newSeries[`production_${product}`] = true;
                newSeries[`target_${product}`] = true;
                newSeries[`sec_${product}`] = true;

                newSeries[`diesel_per_${product}`] = true;
                newSeries[`lpg_per_${product}`] = true;
            });

            newSeries['diesel'] = true;
            newSeries['diesel_target'] = true;
            newSeries['lpg'] = true;
            newSeries['lpg_target'] = true;

            newSeries['calculated_diesel_kwh'] = true;
            newSeries['calculated_lpg_kwh'] = true;
            newSeries['calculated_total_kwh'] = true;

            setMonthSeries(newSeries);
        }
    };

    const toggleMonthSeries = (seriesName) => {
        setMonthSeries(prev => ({
            ...prev,
            [seriesName]: !prev[seriesName]
        }));
    };

    const chartDataRechartss = monthlyData.categories.map((date, index) => {
        const dataPoint = {
            date,
            kWh: monthSeries.kWh ? monthlyData.kWh[index] : null,
            cost: monthSeries.cost ? monthlyData.cost[index] : null,
            entries: monthlyData.entries[index],
        };

        dataPoint['calculated_diesel_kwh'] = monthSeries.calculated_diesel_kwh ? 
            (monthlyData.calculated_diesel_kwh?.[index] || 0) : null;
        dataPoint['calculated_lpg_kwh'] = monthSeries.calculated_lpg_kwh ? 
            (monthlyData.calculated_lpg_kwh?.[index] || 0) : null;
        dataPoint['calculated_total_kwh'] = monthSeries.calculated_total_kwh ? 
            (monthlyData.calculated_total_kwh?.[index] || 0) : null;

        if (monthlyData.energy_consumption) {
            dataPoint['diesel'] = monthSeries.diesel ? monthlyData.energy_consumption.Diesel?.[index] || 0 : null;
            dataPoint['lpg'] = monthSeries.lpg ? monthlyData.energy_consumption.LPG?.[index] || 0 : null;

            dataPoint['diesel_target'] = monthSeries.diesel_target ? 
                (monthlyData.energy_target.Diesel[index] || machineConfig?.target_diesel || 0) : null;
            dataPoint['lpg_target'] = monthSeries.lpg_target ? 
                (monthlyData.energy_target.LPG[index] || machineConfig?.target_lpg || 0) : null;
        }

        Object.keys(monthlyData.production).forEach(product => {
            dataPoint[`production_${product}`] = monthSeries[`production_${product}`] ?
                (monthlyData.production[product][index] || 0) : null;
        });

        Object.keys(monthlyData.target_production).forEach(product => {
            const targetValue = monthlyData.target_production[product][index];
            dataPoint[`target_${product}`] = monthSeries[`target_${product}`] ?
                (typeof targetValue === 'number' ? targetValue : Number(targetValue) || 0) : null;
        });

        Object.keys(monthlyData.production_per_kWh).forEach(product => {
            dataPoint[`sec_${product}`] = monthSeries[`sec_${product}`] ?
                (monthlyData.production_per_kWh[product][index] || 0) : null;
        });

        Object.keys(monthlyData.production_per_energy?.Diesel || {}).forEach(product => {
            dataPoint[`diesel_per_${product}`] = monthSeries[`diesel_per_${product}`] ?
                (monthlyData.production_per_energy.Diesel[product][index] || 0) : null;
        });

        Object.keys(monthlyData.production_per_energy?.LPG || {}).forEach(product => {
            dataPoint[`lpg_per_${product}`] = monthSeries[`lpg_per_${product}`] ?
                (monthlyData.production_per_energy.LPG[product][index] || 0) : null;
        });

        return dataPoint;
    });

    const syncIds = "charts";
    const margins = { top: 10, right: 30, left: 0, bottom: 0 };
    const xAxisPropss = {
        dataKey: "date",
        tick: {
            fontSize: 11,
            angle: -45,
            textAnchor: 'end',
        },
        tickMargin: 10,
        interval: 0,
        height: 60,
        allowDuplicatedCategory: true,
    };
    const yAxisPropss = {
        width: 60,
        tick: { fontSize: 11, fontFamily: 'monospace' },
        tickFormatter: (val) => val === null ? '' : val.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }),
    };

    const tooltipPropss = {
        content: ({ active, payload, label }) => {
            if (!active || !payload || !payload.length) return null;

            const productUnits = {};
            Object.keys(monthlyData.production).forEach(product => {
                const productData = products.find(p => p.product_name === product);
                productUnits[product.toLowerCase()] = productData?.weight_unit || 'unit';
            });

            const dieselTarget = payload.find(item => item.dataKey === 'diesel_target')?.value;
            const lpgTarget = payload.find(item => item.dataKey === 'lpg_target')?.value;

            return (
                <div style={{
                    backgroundColor: 'rgba(150, 150, 150, 0.4)',
                    padding: '4px',
                    border: '1px solid rgba(0, 0, 0, 0.1)',
                    borderRadius: '3px',
                    fontSize: '12px',
                    minWidth: '120px',
                    backdropFilter: 'blur(3px)'
                }}>
                    <div style={{
                        margin: 0,
                        padding: '3px',
                        backgroundColor: 'rgba(211, 211, 211, 0.7)',
                        borderRadius: '3px',
                        marginBottom: '3px',
                        textAlign: 'center',
                        fontSize: '0.9em'
                    }}>
                        <strong>{label}</strong>
                    </div>

                    {payload
                        .filter(item => !['diesel_target', 'lpg_target'].includes(item.dataKey))
                        .map((entry, index) => {
                            let unit = '';
                            const dataKey = entry.dataKey.toLowerCase();
                            if (entry.dataKey.toLowerCase().includes('calculated_')) {
                                unit = ' kWh';
                            }

                            if (dataKey === 'kwh') unit = ' kWh';
                            else if (dataKey === 'cost') unit = ' Rs';
                            else if (dataKey === 'diesel') unit = ' L';
                            else if (dataKey === 'lpg') unit = ' kg';
                            else if (dataKey.startsWith('diesel_per_')) {
                                const productKey = dataKey.replace('diesel_per_', '');
                                unit = ` L/${productUnits[productKey] || 'unit'}`;
                            }
                            else if (dataKey.startsWith('lpg_per_')) {
                                const productKey = dataKey.replace('lpg_per_', '');
                                unit = ` kg/${productUnits[productKey] || 'unit'}`;
                            }
                            else if (dataKey.startsWith('sec_')) {
                                const productKey = dataKey.replace('sec_', '');
                                unit = ` kWh/${productUnits[productKey] || 'unit'}`;
                            }
                            else if (dataKey.includes('target_')) {
                                const productKey = dataKey.replace('target_', '');
                                unit = ` kWh/${productUnits[productKey] || 'unit'}`;
                            }
                            else if (dataKey.includes('production_')) {
                                const productKey = dataKey.replace('production_', '');
                                unit = ` ${productUnits[productKey] || 'unit'}`;
                            }

                            const numericValue = typeof entry.value === 'number' ? entry.value :
                                entry.value !== null ? Number(entry.value) : null;

                            return (
                                <div key={`item-${index}`} style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    margin: '2px 0'
                                }}>
                                    <span style={{
                                        display: 'inline-block',
                                        width: '8px',
                                        height: '8px',
                                        borderRadius: '50%',
                                        backgroundColor: entry.color || '#000',
                                        marginRight: '5px',
                                        flexShrink: 0
                                    }} />
                                    <span style={{ marginRight: '3px', fontSize: '0.9em' }}>{entry.name}:</span>
                                    <strong style={{ fontSize: '0.9em' }}>
                                        {numericValue === null ? 'N/A' : numericValue.toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        })}
                                        {numericValue !== null && unit}
                                    </strong>
                                </div>
                            );
                        })
                    }

                    {dieselTarget !== undefined && Object.keys(productUnits).map((productKey, idx) => (
                        <div key={`diesel-target-${idx}`} style={{
                            display: 'flex',
                            alignItems: 'center',
                            margin: '2px 0'
                        }}>
                            <span style={{
                                display: 'inline-block',
                                width: '8px',
                                height: '8px',
                                borderRadius: '50%',
                                backgroundColor: getTargetColor(),
                                marginRight: '5px',
                                flexShrink: 0
                            }} />
                            <span style={{ marginRight: '3px', fontSize: '0.9em' }}>
                                Diesel {productKey} Target:
                            </span>
                            <strong style={{ fontSize: '0.9em' }}>
                                {dieselTarget.toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                })}
                                {` L/${productUnits[productKey]}`}
                            </strong>
                        </div>
                    ))}

                    {lpgTarget !== undefined && Object.keys(productUnits).map((productKey, idx) => (
                        <div key={`lpg-target-${idx}`} style={{
                            display: 'flex',
                            alignItems: 'center',
                            margin: '2px 0'
                        }}>
                            <span style={{
                                display: 'inline-block',
                                width: '8px',
                                height: '8px',
                                borderRadius: '50%',
                                backgroundColor: getTargetColor(),
                                marginRight: '5px',
                                flexShrink: 0
                            }} />
                            <span style={{ marginRight: '3px', fontSize: '0.9em' }}>
                                LPG {productKey} Target:
                            </span>
                            <strong style={{ fontSize: '0.9em' }}>
                                {lpgTarget.toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                })}
                                {` kg/${productUnits[productKey]}`}
                            </strong>
                        </div>
                    ))}
                </div>
            );
        },
        contentStyle: {
            backgroundColor: 'transparent',
            border: 'none',
            padding: 0,
            margin: 0
        },
        wrapperStyle: {
            backgroundColor: 'transparent',
            boxShadow: 'none'
        }
    };

    const getYAxisLabel = (chartType, products) => {
        const units = [...new Set(products.map(p => p.weight_unit))];
        const unitLabel = units.length === 1 ? units[0] : units.join(' / ');

        switch (chartType) {
            case 'enpi':
                return 'EnPI vs Target';
            case 'energy-cost':
                return 'kWh vs Cost';
            case 'production':
                return unitLabel;
            case 'diesel-enpi':
                return 'Diesel EnPI vs Target';
            case 'diesel-consumption':
                return 'Diesel (L)';
            case 'lpg-enpi':
                return 'LPG EnPI vs Target';
            case 'lpg-consumption':
                return 'LPG (kg)';
            default:
                return '';
        }
    };


    useEffect(() => {
        const fetchProductionSummary = async () => {
            try {
                const token = sessionStorage.getItem('token');
                const today = new Date().toISOString().split('T')[0];
                const response = await axios.get(`${BaseURL}meters/enpi-dashboard-summary-update/`, {
                    params: {
                        department: machine_id,
                        date: today
                    },
                    headers: {
                        'Authorization': `Token ${token}`
                    }
                });

                const getAllProductNames = (data) => {
                    const products = new Set();
                    Object.values(data).forEach(periodData => {
                        if (periodData && periodData.length > 0) {
                            Object.keys(periodData[0]).forEach(key => {
                                if (!['Date', 'From', 'To', 'Department', 'kWh', 'Cost', 'Diesel', 'LPG'].includes(key)) {
                                    products.add(key);
                                }
                            });
                        }
                    });
                    return Array.from(products);
                };

                const productNames = getAllProductNames(response.data);

                const transformData = (data) => {
                    if (!data || data.length === 0) {
                        const emptyData = {
                            total_kwh: 0,
                            diesel: 0,
                            diesel_target: 0,
                            lpg: 0,
                            lpg_target: 0,
                            production: {},
                            target: {},
                            units_per_product: {},
                            units: {},
                            diesel_per_product: {},
                            lpg_per_product: {}
                        };

                        productNames.forEach(product => {
                            const productName = product.toLowerCase();
                            emptyData.production[productName] = { value: 0, unit: 'ton' };
                            emptyData.target[productName] = { value: 0, unit: 'ton' };
                            emptyData.units[productName] = 'ton';
                            emptyData.units_per_product[`${productName}_per_unit`] = {
                                value: 0,
                                unit: 'kWh/ton'
                            };
                            emptyData.diesel_per_product[`${productName}_per_unit`] = {
                                value: 0,
                                unit: 'L/ton'
                            };
                            emptyData.lpg_per_product[`${productName}_per_unit`] = {
                                value: 0,
                                unit: 'Kg/ton'
                            };
                        });

                        return emptyData;
                    }

                    const entry = data[0];
                    const productKeys = Object.keys(entry).filter(key =>
                        !['Date', 'From', 'To', 'Department', 'kWh', 'Cost', 'Diesel', 'LPG'].includes(key)
                    );

                    const parseFuelValueAndTarget = (fuelStr) => {
                        if (!fuelStr) return { value: 0, target: 0 };
                        const parts = fuelStr.split('/').map(s => s.trim());
                        const [valuePart, targetPart] = parts;
                        const [value, unit] = valuePart.split(' ');
                        const [targetValue] = targetPart.split(' ');

                        return {
                            value: parseFloat(value) || 0,
                            target: parseFloat(targetValue) || 0,
                            unit: unit
                        };
                    };

                    const dieselData = parseFuelValueAndTarget(entry.Diesel);
                    const lpgData = parseFuelValueAndTarget(entry.LPG);

                    const production = {};
                    const target = {};
                    const units_per_product = {};
                    const diesel_per_product = {};
                    const lpg_per_product = {};
                    const units = {};

                    productKeys.forEach(product => {
                        const [actualStr, targetStr] = entry[product].split('/').map(s => s.trim());
                        const [actualValue, actualUnit] = actualStr.split(' ');
                        const [targetValue, targetUnit] = targetStr.split(' ');

                        const productName = product.toLowerCase();
                        const actualNum = parseFloat(actualValue) || 0;
                        const targetNum = parseFloat(targetValue) || 0;

                        production[productName] = { value: actualNum, unit: actualUnit };
                        target[productName] = { value: targetNum, unit: targetUnit };
                        units[productName] = actualUnit;
                        units_per_product[`${productName}_per_unit`] = {
                            value: actualNum > 0 ? (entry.kWh || 0) / actualNum : 0,
                            unit: `kWh/${actualUnit}`
                        };

                        diesel_per_product[`${productName}_per_unit`] = {
                            value: actualNum > 0 ? dieselData.value / actualNum : 0,
                            unit: `L/${actualUnit}`
                        };

                        lpg_per_product[`${productName}_per_unit`] = {
                            value: actualNum > 0 ? lpgData.value / actualNum : 0,
                            unit: `Kg/${actualUnit}`
                        };
                    });

                    productNames.forEach(product => {
                        const productName = product.toLowerCase();
                        if (!production[productName]) {
                            production[productName] = { value: 0, unit: 'ton' };
                            target[productName] = { value: 0, unit: 'ton' };
                            units[productName] = 'ton';
                            units_per_product[`${productName}_per_unit`] = {
                                value: 0,
                                unit: 'kWh/ton'
                            };
                            diesel_per_product[`${productName}_per_unit`] = {
                                value: 0,
                                unit: 'L/ton'
                            };
                            lpg_per_product[`${productName}_per_unit`] = {
                                value: 0,
                                unit: 'Kg/ton'
                            };
                        }
                    });

                    return {
                        total_kwh: entry.kWh || 0,
                        diesel: dieselData.value,
                        diesel_target: dieselData.target,
                        lpg: lpgData.value,
                        lpg_target: lpgData.target,
                        production,
                        target,
                        units_per_product,
                        diesel_per_product,
                        lpg_per_product,
                        units
                    };
                };

                setSummaryData({
                    today: transformData(response.data.todays),
                    yesterday: transformData(response.data.yesterdays),
                    current_month: transformData(response.data.current_month),
                    last_month: transformData(response.data.last_month)
                });

            } catch (err) {
                console.log(err.message);
            }
        };

        if (machine_id) {
            fetchProductionSummary();
        }
    }, [machine_id]);

    useEffect(() => {
        const fetchMachineConfig = async () => {
            try {
                const token = sessionStorage.getItem('token');
                const response = await axios.get(`${BaseURL}meters/machine/`, {
                    headers: {
                        'Authorization': `Token ${token}`
                    }
                });

                if (response.data && response.data.length > 0) {
                    const machine = response.data.find(m => m.machine_name === machineName);
                    if (machine) {
                        setMachineConfig({
                            diesel: machine.diesel,
                            lpg: machine.lpg,
                            target_diesel: machine.target_diesel,
                            target_lpg: machine.target_lpg
                        });
                    }
                }
            } catch (err) {
                console.log(err.message);
            }
        };

        if (machineName) {
            fetchMachineConfig();
        }
    }, [machineName]);

    const handleMonthChange = (e) => setSelectedMonth(parseInt(e.target.value));
    const handleYearChange = (e) => setSelectedYear(parseInt(e.target.value));
    const handleNewYearChange = (e) => setSelectedNewYear(parseInt(e.target.value));

    useEffect(() => {
        if (machineId) {
            fetchMonthlyData();
        }
    }, [selectedNewYear, machineId, machineTargets]);

    const fetchMonthlyData = async () => {
        try {
            const response = await axios.post(`${BaseURL}meters/enpi-production-monthly-bar/`, {
                machine_id: machineId,
                year: selectedNewYear
            });

            const { monthly_data } = response.data;

            const newMonthlyData = {
                categories: monthNames,
                kWh: Array(12).fill(0),
                cost: Array(12).fill(0),
                co2: Array(12).fill(0),
                calculated_diesel_kwh: Array(12).fill(0),
                calculated_lpg_kwh: Array(12).fill(0),
                calculated_total_kwh: Array(12).fill(0),
                production: {},
                production_per_kWh: {},
                production_per_energy: {
                    Diesel: {},
                    LPG: {}
                },
                energy_consumption: {
                    Diesel: Array(12).fill(0),
                    LPG: Array(12).fill(0)
                },
                energy_target: {
                    Diesel: Array(12).fill(0),
                    LPG: Array(12).fill(0)
                },
                target_production: {},
                entries: Array(12).fill(0),
            };

            if (machineTargets && Object.keys(machineTargets).length > 0) {
                Object.entries(machineTargets).forEach(([productName, targetValue]) => {
                    newMonthlyData.target_production[productName] = Array(12).fill(
                        typeof targetValue === 'number' ? targetValue : Number(targetValue)
                    );
                });
            }

            monthly_data.forEach(monthData => {
                const monthIndex = monthData.month - 1;

                newMonthlyData.kWh[monthIndex] = monthData.kWh || 0;
                newMonthlyData.cost[monthIndex] = monthData.cost || 0;
                newMonthlyData.co2[monthIndex] = monthData.co2 || 0;
                newMonthlyData.entries[monthIndex] = monthData.entries || 0;
                newMonthlyData.calculated_diesel_kwh[monthIndex] = monthData.calculated_diesel_kwh || 0;
                newMonthlyData.calculated_lpg_kwh[monthIndex] = monthData.calculated_lpg_kwh || 0;
                newMonthlyData.calculated_total_kwh[monthIndex] = monthData.calculated_total_kwh || 0;

                if (monthData.energy_consumption) {
                    if (monthData.energy_consumption.Diesel) {
                        newMonthlyData.energy_consumption.Diesel[monthIndex] = monthData.energy_consumption.Diesel || 0;
                    }
                    if (monthData.energy_consumption.LPG) {
                        newMonthlyData.energy_consumption.LPG[monthIndex] = monthData.energy_consumption.LPG || 0;
                    }
                }

                if (monthData.energy_target) {
                    if (monthData.energy_target.Diesel) {
                        newMonthlyData.energy_target.Diesel[monthIndex] = monthData.energy_target.Diesel || 0;
                    }
                    if (monthData.energy_target.LPG) {
                        newMonthlyData.energy_target.LPG[monthIndex] = monthData.energy_target.LPG || 0;
                    }
                }

                Object.entries(monthData.target_production || {}).forEach(([product, value]) => {
                    if (value !== 0 && value !== null) {
                        if (!newMonthlyData.target_production[product]) {
                            newMonthlyData.target_production[product] = Array(12).fill(0);
                        }
                        newMonthlyData.target_production[product][monthIndex] = value;
                    }
                });

                Object.entries(monthData.production || {}).forEach(([product, value]) => {
                    if (!newMonthlyData.production[product]) {
                        newMonthlyData.production[product] = Array(12).fill(0);
                    }
                    newMonthlyData.production[product][monthIndex] = value || 0;
                });

                Object.entries(monthData.production_per_kWh || {}).forEach(([product, value]) => {
                    if (!newMonthlyData.production_per_kWh[product]) {
                        newMonthlyData.production_per_kWh[product] = Array(12).fill(0);
                    }
                    newMonthlyData.production_per_kWh[product][monthIndex] = value || 0;
                });

                if (monthData.production_per_energy?.Diesel) {
                    Object.entries(monthData.production_per_energy.Diesel).forEach(([product, value]) => {
                        if (!newMonthlyData.production_per_energy.Diesel[product]) {
                            newMonthlyData.production_per_energy.Diesel[product] = Array(12).fill(0);
                        }
                        newMonthlyData.production_per_energy.Diesel[product][monthIndex] = value || 0;
                    });
                }

                if (monthData.production_per_energy?.LPG) {
                    Object.entries(monthData.production_per_energy.LPG).forEach(([product, value]) => {
                        if (!newMonthlyData.production_per_energy.LPG[product]) {
                            newMonthlyData.production_per_energy.LPG[product] = Array(12).fill(0);
                        }
                        newMonthlyData.production_per_energy.LPG[product][monthIndex] = value || 0;
                    });
                }
            });

            setMonthlyData(newMonthlyData);
            initializeSeriesState(response.data);
        } catch (error) {
            console.error('Error fetching production data:', error);
        }
    };

    const getProductColor = (productName) => {
        const darkColorMap = {
            'diesel': '#8B0000',
            'lpg': '#006400',
            'electricity': '#00008B',
            'gasoline': '#8B4500',
            'natural_gas': '#4B0082',
            'coal': '#2F4F4F',
            'biofuel': '#556B2F',
            'hydrogen': '#800080'
        };

        const extendedColorPalette = [
            '#8B008B', '#8B4513', '#483D8B', '#2E8B57', '#ffb397ff',
            '#5D478B', '#ffda0bff', '#ff4080ff', '#8B4789', '#8B3A3A',
            '#ff8c00ff', '#8B5A00', '#8B0000', '#95faf2ff', '#0000ffff',
            '#8B4500', '#ffa2f0ff', '#2F4F4F', '#c5ff60ff', '#800080'
        ];

        const normalized = productName.toLowerCase().replace(/\s+/g, '_');

        if (darkColorMap[normalized]) {
            return darkColorMap[normalized];
        }

        const stringHash = (str) => {
            let hash = 0;
            for (let i = 0; i < str.length; i++) {
                hash = str.charCodeAt(i) + ((hash << 5) - hash);
            }
            return Math.abs(hash);
        };

        const colorIndex = stringHash(normalized) % extendedColorPalette.length;
        return extendedColorPalette[colorIndex];
    };

    const stringToColor = (str, isTarget = false) => {
        if (isTarget) return '#ff0000';

        const getBaseProduct = (s) => {
            const prefixes = [
                'diesel_per_', 'lpg_per_', 
                'kwh_per_', 'enpi_', 'target_'
            ];
            for (const prefix of prefixes) {
                if (s.startsWith(prefix)) {
                    return s.replace(prefix, '');
                }
            }
            return s;
        };

        const baseProduct = getBaseProduct(str);
        const baseColor = getProductColor(baseProduct);

        if (str.startsWith('diesel_per_')) return shiftHue(baseColor, 40);
        if (str.startsWith('lpg_per_')) return shiftHue(baseColor, -40);
        if (str.startsWith('kwh_per_') || str.startsWith('enpi_')) return shiftHue(baseColor, 80);
        if (str.startsWith('target_')) return '#ff0000';

        return baseColor;
    };

    const shiftHue = (hexColor, degrees) => {
        let [h, s, l] = hexToHsl(hexColor);
        h = (h + degrees) % 360;
        if (h < 0) h += 360;
        return hslToHex(h, s, l);
    };

    const hexToHsl = (hex) => {
        let r = parseInt(hex.substring(1, 3), 16) / 255;
        let g = parseInt(hex.substring(3, 5), 16) / 255;
        let b = parseInt(hex.substring(5, 7), 16) / 255;

        let max = Math.max(r, g, b);
        let min = Math.min(r, g, b);
        let h, s, l = (max + min) / 2;

        if (max === min) {
            h = s = 0;
        } else {
            let d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            switch (max) {
                case r: h = (g - b) / d + (g < b ? 6 : 0); break;
                case g: h = (b - r) / d + 2; break;
                case b: h = (r - g) / d + 4; break;
            }
            h *= 60;
        }

        return [h, s * 100, l * 100];
    };

    const hslToHex = (h, s, l) => {
        h /= 360;
        s /= 100;
        l /= 100;

        let r, g, b;

        if (s === 0) {
            r = g = b = l;
        } else {
            const hue2rgb = (p, q, t) => {
                if (t < 0) t += 1;
                if (t > 1) t -= 1;
                if (t < 1 / 6) return p + (q - p) * 6 * t;
                if (t < 1 / 2) return q;
                if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
                return p;
            };

            const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            const p = 2 * l - q;

            r = hue2rgb(p, q, h + 1 / 3);
            g = hue2rgb(p, q, h);
            b = hue2rgb(p, q, h - 1 / 3);
        }

        const toHex = (x) => {
            const hex = Math.round(x * 255).toString(16);
            return hex.length === 1 ? '0' + hex : hex;
        };

        return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
    };

    const getTargetColor = () => {
        return '#ff0000';
    };

    const getProductColors = (productName) => {
        const darkColorMap = {
            'diesel': '#8B0000',
            'lpg': '#006400',
            'electricity': '#00008B',
            'gasoline': '#8B4500',
            'natural_gas': '#4B0082',
            'coal': '#2F4F4F',
            'biofuel': '#556B2F',
            'hydrogen': '#800080'
        };

        const extendedColorPalette = [
            '#8B008B', '#8B4513', '#483D8B', '#2E8B57', '#ffb397ff',
            '#5D478B', '#ffda0bff', '#ff4080ff', '#8B4789', '#8B3A3A',
            '#ff8c00ff', '#8B5A00', '#8B0000', '#95faf2ff', '#0000ffff',
            '#8B4500', '#ffa2f0ff', '#2F4F4F', '#c5ff60ff', '#800080'
        ];

        const normalized = productName.toLowerCase().replace(/\s+/g, '_');

        if (darkColorMap[normalized]) {
            return darkColorMap[normalized];
        }

        const stringHash = (str) => {
            let hash = 0;
            for (let i = 0; i < str.length; i++) {
                hash = str.charCodeAt(i) + ((hash << 5) - hash);
            }
            return Math.abs(hash);
        };

        const colorIndex = stringHash(normalized) % extendedColorPalette.length;
        return extendedColorPalette[colorIndex];
    };

    const stringToColors = (str, isTarget = false) => {
        if (isTarget) return '#ff0000';

        const getBaseProduct = (s) => {
            const prefixes = [
                'diesel_per_', 'lpg_per_', 
                'kwh_per_', 'enpi_', 'target_'
            ];
            for (const prefix of prefixes) {
                if (s.startsWith(prefix)) {
                    return s.replace(prefix, '');
                }
            }
            return s;
        };

        const baseProduct = getBaseProduct(str);
        const baseColor = getProductColors(baseProduct);

        if (str.startsWith('diesel_per_')) return shiftHues(baseColor, 40);
        if (str.startsWith('lpg_per_')) return shiftHues(baseColor, -40);
        if (str.startsWith('kwh_per_') || str.startsWith('enpi_')) return shiftHues(baseColor, 80);
        if (str.startsWith('target_')) return '#ff0000';

        return baseColor;
    };

    const shiftHues = (hexColor, degrees) => {
        let [h, s, l] = hexToHsls(hexColor);
        h = (h + degrees) % 360;
        if (h < 0) h += 360;
        return hslToHexs(h, s, l);
    };

    const hexToHsls = (hex) => {
        let r = parseInt(hex.substring(1, 3), 16) / 255;
        let g = parseInt(hex.substring(3, 5), 16) / 255;
        let b = parseInt(hex.substring(5, 7), 16) / 255;

        let max = Math.max(r, g, b);
        let min = Math.min(r, g, b);
        let h, s, l = (max + min) / 2;

        if (max === min) {
            h = s = 0;
        } else {
            let d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            switch (max) {
                case r: h = (g - b) / d + (g < b ? 6 : 0); break;
                case g: h = (b - r) / d + 2; break;
                case b: h = (r - g) / d + 4; break;
            }
            h *= 60;
        }

        return [h, s * 100, l * 100];
    };

    const hslToHexs = (h, s, l) => {
        h /= 360;
        s /= 100;
        l /= 100;

        let r, g, b;

        if (s === 0) {
            r = g = b = l;
        } else {
            const hue2rgb = (p, q, t) => {
                if (t < 0) t += 1;
                if (t > 1) t -= 1;
                if (t < 1 / 6) return p + (q - p) * 6 * t;
                if (t < 1 / 2) return q;
                if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
                return p;
            };

            const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            const p = 2 * l - q;

            r = hue2rgb(p, q, h + 1 / 3);
            g = hue2rgb(p, q, h);
            b = hue2rgb(p, q, h - 1 / 3);
        }

        const toHex = (x) => {
            const hex = Math.round(x * 255).toString(16);
            return hex.length === 1 ? '0' + hex : hex;
        };

        return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
    };

    useEffect(() => {
        if (machineId) {
            fetchMachineTargets();
            fetchProductionChartData();
        }
    }, [machineId, selectedMonth, selectedYear]);

    const fetchMachineTargets = async () => {
        try {
            const response = await axios.get(`${BaseURL}meters/machine/`);
            const machineData = response.data.find(machine => machine.machine_id === machineId);
            if (machineData && machineData.targets) {
                setMachineTargets(machineData.targets);
            }
            setMachineConfig(prev => ({
                ...prev,
                target_diesel: machineData.target_diesel,
                target_lpg: machineData.target_lpg
            }));
        } catch (error) {
            console.error('Error fetching machine targets:', error);
        }
    };

    const fetchProductionChartData = async () => {
        try {
            const response = await axios.post(`${BaseURL}meters/enpi-daily-production-bar/`, {
                machine_id: machineId,
                month: selectedMonth,
                year: selectedYear
            });

            const { chart_data, products } = response.data;
            setProducts(products || []);

            const categories = chart_data.map(entry => entry.date);
            setChartData({
                categories,
                chartData: chart_data
            });
            console.log('Chart data keys:', Object.keys(chartDataRecharts[0] || {}));
        } catch (error) {
            console.error('Error fetching production data:', error);
        }
    };



    const [activeTab, setActiveTab] = useState("Daily Report");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [monthlyfromDate, setmonthlyFromDate] = useState(null);
    const [monthlytoDate, setmonthlyToDate] = useState(null);
    const [dailyreportData, setDailyreportData] = useState([]);
    const [currentdailyreportPage, setCurrentdailyreportPage] = useState(1);
    const [currentmonthlyreportPage, setCurrentmonthlyreportPage] = useState(1);
    const [monthsData, setMonthsData] = useState({
        selected_range: "",
        columns: [],
        months: []
    });
    const [dailyloading, setDailyLoading] = useState(false);
    const [monthlyloading, setMonthlyLoading] = useState(false);

    const handleMonthlyFromMonthChange = (date) => {
        setmonthlyFromDate(date);
    };

    const handleMonthlyToMonthChange = (date) => {
        setmonthlyToDate(date);
    };

    const getFormattedDateTime = (date) => {
        const pad = (num) => String(num).padStart(2, "0");
        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
    };

    const tabs = ["Daily Report", "Monthly Report"];

    const handleTabChange = (tab) => {
        setActiveTab(tab);
        if (tab !== "Daily Report") {
            setDailyreportData([]);
            setFromDate(null);
            setToDate(null);
            setCurrentdailyreportPage(1);
        }
        if (tab !== "Monthly Report") {
            setMonthsData({ selected_range: "", columns: [], months: [] });
            setmonthlyFromDate(null);
            setmonthlyToDate(null);
            setCurrentmonthlyreportPage(1);
        }
    };

    const handleGetDailyReport = async () => {
        setDailyLoading(true);
        try {
            const response = await axios.post(`${BaseURL}meters/daily-production-report-update/`, {
                machine_id: machineId,
                start_date: fromDate,
                end_date: toDate,
            });

            const data = response.data;
            console.log("Daily Report:", data);

            const formattedData = data.productions?.map(production => ({
                production_date: production.production_date,
                from_date: production.from_date_time,
                to_date: production.to_date_time,
                production: production.production || {},
                target_production: production.target_production || {},
                totalKwh: production.total_kwh || 0,
                totalCost: production.total_cost || 0,
                totalCo2: production.total_co2 || 0,
                sec: production.sec || {},
                energy_consumption: production.energy_consumption || {},
                energy_target: production.energy_target || {},
                production_per_energy: production.production_per_energy || {}
            })) || [];

            setDailyreportData(formattedData);
            setCurrentdailyreportPage(1);
        } catch (error) {
            console.error("Error fetching daily report:", error);
            setDailyreportData([]);
        } finally {
            setDailyLoading(false);
        }
    };

    const rowsdailyPerPage = 10;
    const totaldailyPages = Math.ceil((dailyreportData?.length || 0) / rowsdailyPerPage);
    const indexOfdailyLastRow = currentdailyreportPage * rowsdailyPerPage;
    const indexOfdailyFirstRow = indexOfdailyLastRow - rowsdailyPerPage;
    const currentDailyRows = dailyreportData?.slice(indexOfdailyFirstRow, indexOfdailyLastRow) || [];

    const handledailyPageChange = (newPage) => {
        setCurrentdailyreportPage(newPage);
    };

    const getProductionValue = (productionObj, key) => {
        if (!productionObj) return 0;
        return productionObj[key] || 0;
    };

    const getProductionKeys = () => {
        if (!dailyreportData || dailyreportData.length === 0) return [];
        const firstItem = dailyreportData[0];
        return firstItem?.production ? Object.keys(firstItem.production) : [];
    };

    const getEnergyColumns = () => {
        const columns = [];

        if (machineConfig.diesel) {
            columns.push(
                { key: 'diesel_consumption', label: 'Diesel', type: 'energy' },
                { key: 'diesel_target', label: 'Diesel Target', type: 'energy_target' },
                ...getProductionKeys().map(key => ({
                    key: `diesel_per_${key}`,
                    label: `Diesel/${key}`,
                    type: 'production_per_energy',
                    product: key
                }))
            );
        }

        if (machineConfig.lpg) {
            columns.push(
                { key: 'lpg_consumption', label: 'LPG', type: 'energy' },
                { key: 'lpg_target', label: 'LPG Target', type: 'energy_target' },
                ...getProductionKeys().map(key => ({
                    key: `lpg_per_${key}`,
                    label: `LPG/${key}`,
                    type: 'production_per_energy',
                    product: key
                }))
            );
        }

        return columns;
    };

    const handleMonthlyReport = async () => {
        setMonthlyLoading(true);
        try {
            const formatDate = (date) => {
                const month = date.getMonth() + 1;
                const year = date.getFullYear();
                return `${year}-${month < 10 ? '0' + month : month}`;
            };

            const formattedFromDate = formatDate(monthlyfromDate);
            const formattedToDate = formatDate(monthlytoDate);

            const response = await axios.post(`${BaseURL}meters/monthly-production-report-update/`, {
                from_month_year: formattedFromDate,
                to_month_year: formattedToDate,
                machine_id: machineId
            });

            setMonthsData(response.data);
            setMonthlyLoading(false);
        } catch (error) {
            console.error("Error fetching monthly report:", error);
            setMonthlyLoading(false);
        }
    };

    const rowsmonthlyPerPage = 10;
    const totalmonthlyPages = Math.ceil(monthsData.months.length / rowsmonthlyPerPage);
    const indexOfmonthlyLastRow = currentmonthlyreportPage * rowsmonthlyPerPage;
    const indexOfmonthlyFirstRow = indexOfmonthlyLastRow - rowsmonthlyPerPage;
    const currentMonthlyMonths = monthsData.months.slice(indexOfmonthlyFirstRow, indexOfmonthlyLastRow);

    const handlemonthlyPageChange = (newPage) => {
        setCurrentmonthlyreportPage(newPage);
    };

    const filteredColumns = monthsData.columns ? monthsData.columns.filter(column => {
        if (column.name.includes('Diesel')) {
            return machineConfig.diesel;
        }
        if (column.name.includes('LPG')) {
            return machineConfig.lpg;
        }
        return true;
    }) : [];


    const handleExportToExcel = async (data, fileName) => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Report');

        const getBase64FromImageUrl = async (url) => {
            const response = await fetch(url);
            const blob = await response.blob();
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result.split(',')[1]);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        };

        const getProductionKeys = () => {
            if (!data || data.length === 0) return [];
            const firstItem = data[0];
            return firstItem?.production ? Object.keys(firstItem.production) : [];
        };
        const productionKeys = getProductionKeys();

        let columnCount = 5;
        columnCount += productionKeys.length * 3;

        if (machineConfig.diesel) {
            columnCount += 2;
            columnCount += productionKeys.length;
        }
        if (machineConfig.lpg) {
            columnCount += 2;
            columnCount += productionKeys.length;
        }

        for (let rowNum = 1; rowNum <= 3; rowNum++) {
            const row = worksheet.getRow(rowNum);
            for (let i = 1; i <= columnCount; i++) {
                row.getCell(i).fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFDDDDDD' },
                };
            }
        }

        try {
            const logoBase64 = await getBase64FromImageUrl('/brad.png');
            const logoId = workbook.addImage({
                base64: logoBase64,
                extension: 'png'
            });

            const centerCol = Math.floor(columnCount / 2) - 1;
            worksheet.addImage(logoId, {
                tl: { col: centerCol, row: 0 },
                br: { col: centerCol + 1, row: 3 },
                editAs: 'oneCell'
            });

            worksheet.getRow(1).height = 30;
            worksheet.getRow(2).height = 30;
            worksheet.getRow(3).height = 30;
        } catch (error) {
            console.error('Error adding logo:', error);
        }

        const dateRow = worksheet.addRow([`From Date: ${fromDate || ''}, To Date: ${toDate || ''}`]);
        worksheet.mergeCells(dateRow.number, 1, dateRow.number, columnCount);
        dateRow.font = { bold: true, size: 14 };
        dateRow.alignment = { horizontal: 'center', vertical: 'middle' };
        dateRow.eachCell(cell => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD9EAD3' },
            };
        });

        const branchRow = worksheet.addRow([`Site: Coimbatore | Machine ID: ${machineId || ''} | Machine Name: ${machineName || ''}`]);
        branchRow.font = { bold: true, size: 12 };
        branchRow.alignment = { horizontal: 'center' };
        worksheet.mergeCells(branchRow.number, 1, branchRow.number, columnCount);
        branchRow.eachCell(cell => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFDDDDDD' },
            };
        });

        const titleRow = worksheet.addRow([`${activeTab || ''}`]);
        titleRow.font = { bold: true, size: 16 };
        titleRow.alignment = { horizontal: 'center' };
        worksheet.mergeCells(titleRow.number, 1, titleRow.number, columnCount);
        titleRow.eachCell(cell => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FF1E90FF' },
            };
        });

        const headers = [
            'Production Date',
            'From Date',
            'To Date',
            'Total kWh',
            'Total Cost'
        ];

        productionKeys.forEach(key => {
            headers.push(key);
            headers.push(`Target ${key}`);
            headers.push(`EnPI ${key}`);
        });

        if (machineConfig.diesel) {
            headers.push('Diesel', 'Diesel Target');
            productionKeys.forEach(key => {
                headers.push(`Diesel/${key}`);
            });
        }
        if (machineConfig.lpg) {
            headers.push('LPG', 'LPG Target');
            productionKeys.forEach(key => {
                headers.push(`LPG/${key}`);
            });
        }

        const headerRow = worksheet.addRow(headers);
        headerRow.font = { bold: true };
        headerRow.eachCell(cell => {
            cell.alignment = { horizontal: 'center', vertical: 'middle' };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFA500' },
            };
        });

        if (data && data.length > 0) {
            const getProductionValue = (productionObj, key) => {
                if (!productionObj) return 0;
                return productionObj[key] || 0;
            };

            const getEnergyValue = (energyObj, type) => {
                if (!energyObj) return 0;
                return energyObj[type] || 0;
            };

            const getProductionPerEnergyValue = (ppeObj, energyType, product) => {
                if (!ppeObj || !ppeObj[energyType]) return 0;
                return ppeObj[energyType][product] || 0;
            };

            data.forEach((row, rowIndex) => {
                const rowData = [
                    row.production_date || '',
                    row.from_date || '',
                    row.to_date || '',
                    (row.totalKwh || 0).toFixed(2),
                    (row.totalCost || 0).toFixed(2)
                ];

                productionKeys.forEach(key => {
                    rowData.push(
                        getProductionValue(row.production, key).toFixed(2),
                        getProductionValue(row.target_production, key).toFixed(2),
                        getProductionValue(row.sec, key).toFixed(2)
                    );
                });

                if (machineConfig.diesel) {
                    rowData.push(
                        getEnergyValue(row.energy_consumption, 'Diesel').toFixed(2),
                        getEnergyValue(row.energy_target, 'Diesel').toFixed(2)
                    );
                    productionKeys.forEach(key => {
                        rowData.push(
                            getProductionPerEnergyValue(row.production_per_energy, 'Diesel', key).toFixed(2)
                        );
                    });
                }
                if (machineConfig.lpg) {
                    rowData.push(
                        getEnergyValue(row.energy_consumption, 'LPG').toFixed(2),
                        getEnergyValue(row.energy_target, 'LPG').toFixed(2)
                    );
                    productionKeys.forEach(key => {
                        rowData.push(
                            getProductionPerEnergyValue(row.production_per_energy, 'LPG', key).toFixed(2)
                        );
                    });
                }

                const dataRow = worksheet.addRow(rowData);
                dataRow.height = 20;
                dataRow.eachCell(cell => {
                    const fillColor = rowIndex % 2 === 0 ? 'FFE8EAF6' : 'FFFFFFFF';
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: fillColor },
                    };
                    cell.alignment = { horizontal: 'center', vertical: 'middle' };
                });
            });
        } else {
            const noDataRow = worksheet.addRow(['No data available']);
            noDataRow.font = { italic: true };
            worksheet.mergeCells(noDataRow.number, 1, noDataRow.number, columnCount);
        }

        const footerRow = worksheet.addRow(['Powered by Innospace']);
        footerRow.font = { bold: true, size: 12 };
        footerRow.alignment = { horizontal: 'center', vertical: 'middle' };
        worksheet.mergeCells(footerRow.number, 1, footerRow.number, columnCount);
        footerRow.eachCell(cell => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFDDDDDD' },
            };
        });

        const columnWidths = [
            20,
            20,
            20,
            15,
            15
        ];

        productionKeys.forEach(() => {
            columnWidths.push(15, 15, 15);
        });

        if (machineConfig.diesel) {
            columnWidths.push(15, 15);
            productionKeys.forEach(() => columnWidths.push(15));
        }
        if (machineConfig.lpg) {
            columnWidths.push(15, 15);
            productionKeys.forEach(() => columnWidths.push(15));
        }

        columnWidths.forEach((width, index) => {
            worksheet.getColumn(index + 1).width = width;
        });

        workbook.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob([buffer], { type: 'application/octet-stream' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            a.click();
            window.URL.revokeObjectURL(url);
        }).catch(error => {
            console.error('Error exporting to Excel:', error);
        });
    };

    const handleMonthlyExportToExcel = async (data, fileName) => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Monthly Report');

        const getBase64FromImageUrl = async (url) => {
            const response = await fetch(url);
            const blob = await response.blob();
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result.split(',')[1]);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        };

        const filteredColumns = data.columns ? data.columns.filter(column => {
            if (column.name.includes('Diesel')) {
                return machineConfig.diesel;
            }
            if (column.name.includes('LPG')) {
                return machineConfig.lpg;
            }
            return true;
        }) : [];

        const columnCount = 2 + filteredColumns.length;

        for (let rowNum = 1; rowNum <= 3; rowNum++) {
            const row = worksheet.getRow(rowNum);
            for (let i = 1; i <= columnCount; i++) {
                row.getCell(i).fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFDDDDDD' },
                };
            }
        }

        try {
            const logoBase64 = await getBase64FromImageUrl('/brad.png');
            const logoId = workbook.addImage({
                base64: logoBase64,
                extension: 'png'
            });

            const centerCol = Math.floor(columnCount / 2) - 1;
            worksheet.addImage(logoId, {
                tl: { col: centerCol, row: 0 },
                br: { col: centerCol + 1, row: 3 },
                editAs: 'oneCell'
            });

            worksheet.getRow(1).height = 30;
            worksheet.getRow(2).height = 30;
            worksheet.getRow(3).height = 30;
        } catch (error) {
            console.error('Error adding logo:', error);
        }

        const titleRow = worksheet.addRow(['Monthly Report']);
        titleRow.font = { bold: true, size: 16 };
        titleRow.alignment = { horizontal: 'center' };
        worksheet.mergeCells(titleRow.number, 1, titleRow.number, columnCount);
        titleRow.eachCell(cell => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FF1E90FF' },
            };
        });

        const dateRangeText = `From: ${monthlyfromDate?.toLocaleDateString('en-US', { year: 'numeric', month: 'long' }) || "Selected from Month"} to ${monthlytoDate?.toLocaleDateString('en-US', { year: 'numeric', month: 'long' }) || "Selected to Month"}`;
        const dateRangeRow = worksheet.addRow([dateRangeText]);
        dateRangeRow.font = { bold: true, size: 14 };
        dateRangeRow.alignment = { horizontal: 'center' };
        worksheet.mergeCells(dateRangeRow.number, 1, dateRangeRow.number, columnCount);
        dateRangeRow.eachCell(cell => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD9EAD3' },
            };
        });

        const machineInfoRow = worksheet.addRow([`Site: Coimbatore | Machine ID: ${machineId || ''} | Machine Name: ${machineName || ''}`]);
        machineInfoRow.font = { bold: true, size: 12 };
        machineInfoRow.alignment = { horizontal: 'center' };
        worksheet.mergeCells(machineInfoRow.number, 1, machineInfoRow.number, columnCount);
        machineInfoRow.eachCell(cell => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFDDDDDD' },
            };
        });

        const headers = ['S.No', 'Month'];
        filteredColumns.forEach(column => {
            headers.push(column.name);
        });

        const headerRow = worksheet.addRow(headers);
        headerRow.font = { bold: true };
        headerRow.eachCell(cell => {
            cell.alignment = { horizontal: 'center', vertical: 'middle' };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFA500' },
            };
        });

        if (data.months && data.months.length > 0 && data.columns) {
            data.months.forEach((month, index) => {
                const rowData = [index + 1, month];

                filteredColumns.forEach(column => {
                    const originalColumnIndex = data.columns.findIndex(c => c.name === column.name);
                    rowData.push(data.columns[originalColumnIndex].data[index].toFixed(2));
                });

                const dataRow = worksheet.addRow(rowData);
                dataRow.eachCell(cell => {
                    const fillColor = index % 2 === 0 ? 'FFE8EAF6' : 'FFFFFFFF';
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: fillColor },
                    };
                    cell.alignment = { horizontal: 'center', vertical: 'middle' };
                });
            });
        } else {
            const noDataRow = worksheet.addRow(['No data available']);
            noDataRow.font = { italic: true };
            worksheet.mergeCells(noDataRow.number, 1, noDataRow.number, columnCount);
        }

        const footerRow = worksheet.addRow(['Powered by Innospace']);
        footerRow.font = { bold: true, size: 12 };
        footerRow.alignment = { horizontal: 'center', vertical: 'middle' };
        worksheet.mergeCells(footerRow.number, 1, footerRow.number, columnCount);
        footerRow.eachCell(cell => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFDDDDDD' },
            };
        });

        const columnWidths = [10, 20];
        filteredColumns.forEach(() => {
            columnWidths.push(15);
        });

        columnWidths.forEach((width, index) => {
            worksheet.getColumn(index + 1).width = width;
        });

        workbook.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob([buffer], { type: 'application/octet-stream' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            a.click();
            window.URL.revokeObjectURL(url);
        }).catch(error => {
            console.error('Error exporting to Excel:', error);
        });
    };

    const generateFilename = () => {
        const formattedFromDate = monthlyfromDate
            ? monthlyfromDate.toLocaleDateString('en-US', { year: 'numeric', month: '2-digit' })
            : "FromDate";
        const formattedToDate = monthlytoDate
            ? monthlytoDate.toLocaleDateString('en-US', { year: 'numeric', month: '2-digit' })
            : "ToDate";

        return `Monthly_Report_${formattedFromDate}_to_${formattedToDate}.xlsx`;
    };

    return (
        <div className="dashboard-container">
            <Header title="BRADKEN EnPI MANAGEMENT DASHBOARD" />

            <div className="card-container" style={{
                border: '1px solid #ccc',
                borderRadius: '10px',
                padding: '20px',
                boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                backgroundColor: '#fff',
                marginTop: '60px',
                maxWidth: window.innerWidth - 200,
                marginLeft: 'auto',
                marginRight: 'auto'
            }}>
                <h3 className="dashboard-subtitle">
                    <span
                        onClick={() => navigate('/EMS/production')}
                        style={{ color: '#007bff', cursor: 'pointer' }}
                        title="Navigate to Dashboard"
                    >
                        MAIN
                    </span> {"/"} {machineName}
                </h3>
                {/* <button
                        style={{
                            padding: '8px 12px',
                            backgroundColor: '#4CAF50',
                            color: 'white',
                            border: 'none',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            marginLeft: '20px',
                        }}
                        onClick={showAddModal}
                    >
                        <FontAwesomeIcon icon={faPlus} style={{ marginRight: '5px' }} />
                        Add
                    </button> */}
                <div className="widgetsss-container" style={{ display: 'flex', flexDirection: 'column', gridTemplateColumns: 'repeat(4, 1fr)', gap: '20px', marginBottom: '20px', marginTop: '20px', maxWidth: '100%', marginLeft: 'auto', marginRight: 'auto' }}>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <div className="widget-container" style={{ width: '100%', marginLeft: "10px", marginRight: "10px" }}>
                            <div className="widget" style={{ padding: '10px', border: '1px solid #ccc', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)', transform: 'disable' }}>
                                <h3>Today's</h3>
                                <div style={{ display: 'table', width: '100%' }}>
                                    <div style={{ display: 'table-row' }}>
                                        <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', paddingBottom: '15px' }}></p>
                                        <p style={{ display: 'table-cell', textAlign: 'center' }}></p>
                                        <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', paddingBottom: '15px', fontWeight: 'bold' }}>
                                            Electricity
                                        </p>
                                        {machineConfig.diesel && (
                                            <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', paddingBottom: '15px', fontWeight: 'bold' }}>
                                                Diesel
                                            </p>
                                        )}
                                        {machineConfig.lpg && (
                                            <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', paddingBottom: '15px', fontWeight: 'bold' }}>
                                                LPG
                                            </p>
                                        )}
                                    </div>
                                    <div style={{ display: 'table-row' }}>
                                        <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', paddingBottom: '15px', fontWeight: 'bold' }}>Total Energy</p>
                                        <p style={{ display: 'table-cell', textAlign: 'center', fontWeight: 'bold' }}>:</p>
                                        <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right' }}>
                                            {(summaryData?.today?.total_kwh || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} kWh
                                        </p>
                                        {machineConfig.diesel && (
                                            <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right' }}>
                                                {(summaryData?.today?.diesel || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} L
                                            </p>
                                        )}
                                        {machineConfig.lpg && (
                                            <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right' }}>
                                                {(summaryData?.today?.lpg || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Kg
                                            </p>
                                        )}
                                    </div>
                                    {summaryData?.today?.production && Object.entries(summaryData.today.production).map(([product, { value, unit }]) => (
                                        <>
                                            <div key={`today-prod-${product}`} style={{ display: 'table-row' }}>
                                                <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', paddingBottom: '15px', fontWeight: 'bold' }}>
                                                    {product.charAt(0).toUpperCase() + product.slice(1)}
                                                </p>
                                                <p style={{ display: 'table-cell', textAlign: 'center', fontWeight: 'bold' }}>:</p>
                                                <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right' }}>
                                                    {value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {unit}
                                                </p>
                                                {machineConfig.diesel && (
                                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right' }}>
                                                        {value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {unit}
                                                    </p>
                                                )}
                                                {machineConfig.lpg && (
                                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right' }}>
                                                        {value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {unit}
                                                    </p>
                                                )}
                                            </div>
                                            {summaryData?.today?.target && summaryData.today.target[product] && (
                                                <div key={`today-target-${product}`} style={{ display: 'table-row' }}>
                                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', paddingBottom: '15px', fontWeight: 'bold' }}>
                                                        Target {product.charAt(0).toUpperCase() + product.slice(1)}
                                                    </p>
                                                    <p style={{ display: 'table-cell', textAlign: 'center', fontWeight: 'bold' }}>:</p>
                                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right' }}>
                                                        {summaryData.today.target[product].value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} kWh/{summaryData.today.target[product].unit}
                                                    </p>
                                                    {machineConfig.diesel && (
                                                        <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right' }}>
                                                            {(summaryData?.today?.diesel_target || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} L/{unit}
                                                        </p>
                                                    )}
                                                    {machineConfig.lpg && (
                                                        <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right' }}>
                                                            {(summaryData?.today?.lpg_target || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Kg/{unit}
                                                        </p>
                                                    )}
                                                </div>
                                            )}
                                            {summaryData?.today?.units_per_product && summaryData.today.units_per_product[`${product}_per_unit`] && (
                                                <div key={`today-unit-${product}`} style={{ display: 'table-row' }}>
                                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', paddingBottom: '15px', fontWeight: 'bold' }}>
                                                        EnPI {product.charAt(0).toUpperCase() + product.slice(1)}
                                                    </p>
                                                    <p style={{ display: 'table-cell', textAlign: 'center', fontWeight: 'bold' }}>:</p>
                                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right' }}>
                                                        {summaryData.today.units_per_product[`${product}_per_unit`].value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {summaryData.today.units_per_product[`${product}_per_unit`].unit}
                                                    </p>
                                                    {machineConfig.diesel && summaryData?.today?.diesel_per_product && (
                                                        <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right' }}>
                                                            {summaryData.today.diesel_per_product[`${product}_per_unit`]?.value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {summaryData.today.diesel_per_product[`${product}_per_unit`]?.unit}
                                                        </p>
                                                    )}
                                                    {machineConfig.lpg && summaryData?.today?.lpg_per_product && (
                                                        <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right' }}>
                                                            {summaryData.today.lpg_per_product[`${product}_per_unit`]?.value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {summaryData.today.lpg_per_product[`${product}_per_unit`]?.unit}
                                                        </p>
                                                    )}
                                                </div>
                                            )}
                                        </>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="widget-container" style={{ width: '100%', marginLeft: "10px", marginRight: "10px" }}>
                            <div className="widget" style={{ padding: '10px', border: '1px solid #ccc', background: 'linear-gradient(145deg, #4caf50, #2b9e36)', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}>
                                <h3>Yesterday</h3>
                                <div style={{ display: 'table', width: '100%' }}>
                                    <div style={{ display: 'table-row' }}>
                                        <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', paddingBottom: '15px' }}></p>
                                        <p style={{ display: 'table-cell', textAlign: 'center' }}></p>
                                        <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', paddingBottom: '15px', fontWeight: 'bold' }}>
                                            Electricity
                                        </p>
                                        {machineConfig.diesel && (
                                            <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', paddingBottom: '15px', fontWeight: 'bold' }}>
                                                Diesel
                                            </p>
                                        )}
                                        {machineConfig.lpg && (
                                            <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', paddingBottom: '15px', fontWeight: 'bold' }}>
                                                LPG
                                            </p>
                                        )}
                                    </div>
                                    <div style={{ display: 'table-row' }}>
                                        <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', paddingBottom: '15px', color: '#ffffff', fontWeight: 'bold' }}>Total Energy</p>
                                        <p style={{ display: 'table-cell', textAlign: 'center', color: '#ffffff', fontWeight: 'bold' }}>:</p>
                                        <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>
                                            {(summaryData?.yesterday?.total_kwh || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} kWh
                                        </p>
                                        {machineConfig.diesel && (
                                            <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>
                                                {(summaryData?.yesterday?.diesel || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} L
                                            </p>
                                        )}
                                        {machineConfig.lpg && (
                                            <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>
                                                {(summaryData?.yesterday?.lpg || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Kg
                                            </p>
                                        )}
                                    </div>
                                    {summaryData?.yesterday?.production && Object.entries(summaryData.yesterday.production).map(([product, { value, unit }]) => (
                                        <>
                                            <div key={`yesterday-prod-${product}`} style={{ display: 'table-row' }}>
                                                <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', paddingBottom: '15px', color: '#ffffff', fontWeight: 'bold' }}>
                                                    {product.charAt(0).toUpperCase() + product.slice(1)}
                                                </p>
                                                <p style={{ display: 'table-cell', textAlign: 'center', color: '#ffffff', fontWeight: 'bold' }}>:</p>
                                                <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>
                                                    {value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {unit}
                                                </p>
                                                {machineConfig.diesel && (
                                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>
                                                        {value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {unit}
                                                    </p>
                                                )}
                                                {machineConfig.lpg && (
                                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>
                                                        {value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {unit}
                                                    </p>
                                                )}
                                            </div>
                                            {summaryData?.yesterday?.target && summaryData.yesterday.target[product] && (
                                                <div key={`yesterday-target-${product}`} style={{ display: 'table-row' }}>
                                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', paddingBottom: '15px', color: '#ffffff', fontWeight: 'bold' }}>
                                                        Target {product.charAt(0).toUpperCase() + product.slice(1)}
                                                    </p>
                                                    <p style={{ display: 'table-cell', textAlign: 'center', color: '#ffffff', fontWeight: 'bold' }}>:</p>
                                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>
                                                        {summaryData.yesterday.target[product].value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} kWh/{summaryData.yesterday.target[product].unit}
                                                    </p>
                                                    {machineConfig.diesel && (
                                                        <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>
                                                            {(summaryData?.yesterday?.diesel_target || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} L/{unit}
                                                        </p>
                                                    )}
                                                    {machineConfig.lpg && (
                                                        <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>
                                                            {(summaryData?.yesterday?.lpg_target || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Kg/{unit}
                                                        </p>
                                                    )}
                                                </div>
                                            )}
                                            {summaryData?.yesterday?.units_per_product && summaryData.yesterday.units_per_product[`${product}_per_unit`] && (
                                                <div key={`yesterday-unit-${product}`} style={{ display: 'table-row' }}>
                                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', paddingBottom: '15px', color: '#ffffff', fontWeight: 'bold' }}>
                                                        EnPI {product.charAt(0).toUpperCase() + product.slice(1)}
                                                    </p>
                                                    <p style={{ display: 'table-cell', textAlign: 'center', color: '#ffffff', fontWeight: 'bold' }}>:</p>
                                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>
                                                        {summaryData.yesterday.units_per_product[`${product}_per_unit`].value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {summaryData.yesterday.units_per_product[`${product}_per_unit`].unit}
                                                    </p>
                                                    {machineConfig.diesel && summaryData?.yesterday?.diesel_per_product && (
                                                        <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>
                                                            {summaryData.yesterday.diesel_per_product[`${product}_per_unit`]?.value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {summaryData.yesterday.diesel_per_product[`${product}_per_unit`]?.unit}
                                                        </p>
                                                    )}
                                                    {machineConfig.lpg && summaryData?.yesterday?.lpg_per_product && (
                                                        <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>
                                                            {summaryData.yesterday.lpg_per_product[`${product}_per_unit`]?.value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {summaryData.yesterday.lpg_per_product[`${product}_per_unit`]?.unit}
                                                        </p>
                                                    )}
                                                </div>
                                            )}
                                        </>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <div className="widget-container" style={{ width: '100%', marginLeft: "10px", marginRight: "10px" }}>
                            <div className="widget" style={{ padding: '10px', border: '1px solid #ccc', background: 'linear-gradient(145deg, #2196f3, #0b7dda)', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}>
                                <h3>Current Month</h3>
                                <div style={{ display: 'table', width: '100%' }}>
                                    <div style={{ display: 'table-row' }}>
                                        <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', paddingBottom: '15px' }}></p>
                                        <p style={{ display: 'table-cell', textAlign: 'center' }}></p>
                                        <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', paddingBottom: '15px', fontWeight: 'bold' }}>
                                            Electricity
                                        </p>
                                        {machineConfig.diesel && (
                                            <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', paddingBottom: '15px', fontWeight: 'bold' }}>
                                                Diesel
                                            </p>
                                        )}
                                        {machineConfig.lpg && (
                                            <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', paddingBottom: '15px', fontWeight: 'bold' }}>
                                                LPG
                                            </p>
                                        )}
                                    </div>
                                    <div style={{ display: 'table-row' }}>
                                        <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', paddingBottom: '15px', color: '#ffffff', fontWeight: 'bold' }}>Total Energy</p>
                                        <p style={{ display: 'table-cell', textAlign: 'center', color: '#ffffff', fontWeight: 'bold' }}>:</p>
                                        <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>
                                            {(summaryData?.current_month?.total_kwh || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} kWh
                                        </p>
                                        {machineConfig.diesel && (
                                            <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>
                                                {(summaryData?.current_month?.diesel || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} L
                                            </p>
                                        )}
                                        {machineConfig.lpg && (
                                            <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>
                                                {(summaryData?.current_month?.lpg || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Kg
                                            </p>
                                        )}
                                    </div>
                                    {summaryData?.current_month?.production && Object.entries(summaryData.current_month.production).map(([product, { value, unit }]) => (
                                        <>
                                            <div key={`month-prod-${product}`} style={{ display: 'table-row' }}>
                                                <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', paddingBottom: '15px', color: '#ffffff', fontWeight: 'bold' }}>
                                                    {product.charAt(0).toUpperCase() + product.slice(1)}
                                                </p>
                                                <p style={{ display: 'table-cell', textAlign: 'center', color: '#ffffff', fontWeight: 'bold' }}>:</p>
                                                <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>
                                                    {value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {unit}
                                                </p>
                                                {machineConfig.diesel && (
                                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>
                                                        {value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {unit}
                                                    </p>
                                                )}
                                                {machineConfig.lpg && (
                                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>
                                                        {value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {unit}
                                                    </p>
                                                )}
                                            </div>
                                            {summaryData?.current_month?.target && summaryData.current_month.target[product] && (
                                                <div key={`month-target-${product}`} style={{ display: 'table-row' }}>
                                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', paddingBottom: '15px', color: '#ffffff', fontWeight: 'bold' }}>
                                                        Target {product.charAt(0).toUpperCase() + product.slice(1)}
                                                    </p>
                                                    <p style={{ display: 'table-cell', textAlign: 'center', color: '#ffffff', fontWeight: 'bold' }}>:</p>
                                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>
                                                        {summaryData.current_month.target[product].value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} kWh/{summaryData.current_month.target[product].unit}
                                                    </p>
                                                    {machineConfig.diesel && (
                                                        <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>
                                                            {(summaryData?.current_month?.diesel_target || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} L/{unit}
                                                        </p>
                                                    )}
                                                    {machineConfig.lpg && (
                                                        <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>
                                                            {(summaryData?.current_month?.lpg_target || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Kg/{unit}
                                                        </p>
                                                    )}
                                                </div>
                                            )}
                                            {summaryData?.current_month?.units_per_product && summaryData.current_month.units_per_product[`${product}_per_unit`] && (
                                                <div key={`month-unit-${product}`} style={{ display: 'table-row' }}>
                                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', paddingBottom: '15px', color: '#ffffff', fontWeight: 'bold' }}>
                                                        EnPI {product.charAt(0).toUpperCase() + product.slice(1)}
                                                    </p>
                                                    <p style={{ display: 'table-cell', textAlign: 'center', color: '#ffffff', fontWeight: 'bold' }}>:</p>
                                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>
                                                        {summaryData.current_month.units_per_product[`${product}_per_unit`].value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {summaryData.current_month.units_per_product[`${product}_per_unit`].unit}
                                                    </p>
                                                    {machineConfig.diesel && summaryData?.current_month?.diesel_per_product && (
                                                        <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>
                                                            {summaryData.current_month.diesel_per_product[`${product}_per_unit`]?.value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {summaryData.current_month.diesel_per_product[`${product}_per_unit`]?.unit}
                                                        </p>
                                                    )}
                                                    {machineConfig.lpg && summaryData?.current_month?.lpg_per_product && (
                                                        <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>
                                                            {summaryData.current_month.lpg_per_product[`${product}_per_unit`]?.value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {summaryData.current_month.lpg_per_product[`${product}_per_unit`]?.unit}
                                                        </p>
                                                    )}
                                                </div>
                                            )}
                                        </>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="widget-container" style={{ width: '100%', marginLeft: "10px", marginRight: "10px" }}>
                            <div className="widget" style={{ padding: '10px', border: '1px solid #ccc', background: 'linear-gradient(145deg, #ed76fd, #e53afd)', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}>
                                <h3>Last Month</h3>
                                <div style={{ display: 'table', width: '100%' }}>
                                    <div style={{ display: 'table-row' }}>
                                        <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', paddingBottom: '15px' }}></p>
                                        <p style={{ display: 'table-cell', textAlign: 'center' }}></p>
                                        <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', paddingBottom: '15px', fontWeight: 'bold' }}>
                                            Electricity
                                        </p>
                                        {machineConfig.diesel && (
                                            <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', paddingBottom: '15px', fontWeight: 'bold' }}>
                                                Diesel
                                            </p>
                                        )}
                                        {machineConfig.lpg && (
                                            <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', paddingBottom: '15px', fontWeight: 'bold' }}>
                                                LPG
                                            </p>
                                        )}
                                    </div>
                                    <div style={{ display: 'table-row' }}>
                                        <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', paddingBottom: '15px', color: '#ffffff', fontWeight: 'bold' }}>Total Energy</p>
                                        <p style={{ display: 'table-cell', textAlign: 'center', color: '#ffffff', fontWeight: 'bold' }}>:</p>
                                        <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>
                                            {(summaryData?.last_month?.total_kwh || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} kWh
                                        </p>
                                        {machineConfig.diesel && (
                                            <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>
                                                {(summaryData?.last_month?.diesel || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} L
                                            </p>
                                        )}
                                        {machineConfig.lpg && (
                                            <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>
                                                {(summaryData?.last_month?.lpg || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Kg
                                            </p>
                                        )}
                                    </div>
                                    {summaryData?.last_month?.production && Object.entries(summaryData.last_month.production).map(([product, { value, unit }]) => (
                                        <>
                                            <div key={`lastmonth-prod-${product}`} style={{ display: 'table-row' }}>
                                                <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', paddingBottom: '15px', color: '#ffffff', fontWeight: 'bold' }}>
                                                    {product.charAt(0).toUpperCase() + product.slice(1)}
                                                </p>
                                                <p style={{ display: 'table-cell', textAlign: 'center', color: '#ffffff', fontWeight: 'bold' }}>:</p>
                                                <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>
                                                    {value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {unit}
                                                </p>
                                                {machineConfig.diesel && (
                                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>
                                                        {value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {unit}
                                                    </p>
                                                )}
                                                {machineConfig.lpg && (
                                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>
                                                        {value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {unit}
                                                    </p>
                                                )}
                                            </div>
                                            {summaryData?.last_month?.target && summaryData.last_month.target[product] && (
                                                <div key={`lastmonth-target-${product}`} style={{ display: 'table-row' }}>
                                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', paddingBottom: '15px', color: '#ffffff', fontWeight: 'bold' }}>
                                                        Target {product.charAt(0).toUpperCase() + product.slice(1)}
                                                    </p>
                                                    <p style={{ display: 'table-cell', textAlign: 'center', color: '#ffffff', fontWeight: 'bold' }}>:</p>
                                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>
                                                        {summaryData.last_month.target[product].value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} kWh/{summaryData.last_month.target[product].unit}
                                                    </p>
                                                    {machineConfig.diesel && (
                                                        <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>
                                                            {(summaryData?.last_month?.diesel_target || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} L/{unit}
                                                        </p>
                                                    )}
                                                    {machineConfig.lpg && (
                                                        <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>
                                                            {(summaryData?.last_month?.lpg_target || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Kg/{unit}
                                                        </p>
                                                    )}
                                                </div>
                                            )}
                                            {summaryData?.last_month?.units_per_product && summaryData.last_month.units_per_product[`${product}_per_unit`] && (
                                                <div key={`lastmonth-unit-${product}`} style={{ display: 'table-row' }}>
                                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', paddingBottom: '15px', color: '#ffffff', fontWeight: 'bold' }}>
                                                        EnPI {product.charAt(0).toUpperCase() + product.slice(1)}
                                                    </p>
                                                    <p style={{ display: 'table-cell', textAlign: 'center', color: '#ffffff', fontWeight: 'bold' }}>:</p>
                                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>
                                                        {summaryData.last_month.units_per_product[`${product}_per_unit`].value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {summaryData.last_month.units_per_product[`${product}_per_unit`].unit}
                                                    </p>
                                                    {machineConfig.diesel && summaryData?.last_month?.diesel_per_product && (
                                                        <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>
                                                            {summaryData.last_month.diesel_per_product[`${product}_per_unit`]?.value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {summaryData.last_month.diesel_per_product[`${product}_per_unit`]?.unit}
                                                        </p>
                                                    )}
                                                    {machineConfig.lpg && summaryData?.last_month?.lpg_per_product && (
                                                        <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right', color: '#ffffff' }}>
                                                            {summaryData.last_month.lpg_per_product[`${product}_per_unit`]?.value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {summaryData.last_month.lpg_per_product[`${product}_per_unit`]?.unit}
                                                        </p>
                                                    )}
                                                </div>
                                            )}
                                        </>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="charts-container" style={{ marginTop: '20px', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <div
                        className="container-4"
                        style={{
                            border: '1px solid #ccc',
                            borderRadius: '10px',
                            padding: '20px',
                            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                            backgroundColor: '#f9f0f3',
                            marginTop: '20px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '100%',
                        }}
                    >
                        <h4>Production Data</h4>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                marginBottom: "30px",
                            }}
                        >
                            <label
                                style={{
                                    fontSize: "14px",
                                    color: "#333",
                                    fontWeight: "bold",
                                    marginRight: "10px",
                                }}
                            >
                                Month:
                            </label>
                            <select
                                value={selectedMonth}
                                onChange={handleMonthChange}
                                style={{
                                    padding: "5px",
                                    marginRight: "20px",
                                    borderRadius: "5px",
                                    border: "1px solid #ccc",
                                }}
                            >
                                {monthNames.map((month, index) => (
                                    <option key={index + 1} value={index + 1}>
                                        {month}
                                    </option>
                                ))}
                            </select>

                            <label
                                style={{
                                    fontSize: "14px",
                                    color: "#333",
                                    fontWeight: "bold",
                                    marginRight: "10px",
                                }}
                            >
                                Year:
                            </label>
                            <select
                                value={selectedYear}
                                onChange={handleYearChange}
                                style={{
                                    padding: "5px",
                                    borderRadius: "5px",
                                    border: "1px solid #ccc",
                                }}
                            >
                                {Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - i).map(year => (
                                    <option key={year} value={year}>
                                        {year}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div style={{ width: '100%', marginTop: '20px' }}>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'center',
                                marginBottom: '10px',
                                flexWrap: 'wrap',
                                gap: '20px'
                            }}>
                                <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                cursor: 'pointer',
                                                opacity: visibleSeries.kWh ? 1 : 0.5
                                            }}
                                            onClick={() => toggleSeries('kWh')}
                                        >
                                            <div style={{
                                                width: '10px',
                                                height: '10px',
                                                backgroundColor: '#6eff54',
                                                marginRight: '5px',
                                                borderRadius: '3px'
                                            }}></div>
                                            <span style={{ fontSize: '10px' }}>kWh</span>
                                        </div>
                                {machineConfig?.diesel && (
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            cursor: 'pointer',
                                            opacity: visibleSeries.calculated_diesel_kwh ? 1 : 0.5
                                        }}
                                        onClick={() => toggleSeries('calculated_diesel_kwh')}
                                    >
                                        <div style={{
                                            width: '10px',
                                            height: '10px',
                                            backgroundColor: '#FFA500',
                                            marginRight: '5px',
                                            borderRadius: '3px'
                                        }}></div>
                                        <span style={{ fontSize: '10px' }}>Diesel kWh</span>
                                    </div>
                                )}
                                
                                {machineConfig?.lpg && (
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            cursor: 'pointer',
                                            opacity: visibleSeries.calculated_lpg_kwh ? 1 : 0.5
                                        }}
                                        onClick={() => toggleSeries('calculated_lpg_kwh')}
                                    >
                                        <div style={{
                                            width: '10px',
                                            height: '10px',
                                            backgroundColor: '#00ffea',
                                            marginRight: '5px',
                                            borderRadius: '3px'
                                        }}></div>
                                        <span style={{ fontSize: '10px' }}>LPG kWh</span>
                                    </div>
                                )}
                                
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        cursor: 'pointer',
                                        opacity: visibleSeries.calculated_total_kwh ? 1 : 0.5
                                    }}
                                    onClick={() => toggleSeries('calculated_total_kwh')}
                                >
                                    <div style={{
                                        width: '10px',
                                        height: '10px',
                                        backgroundColor: '#4169E1',
                                        marginRight: '5px',
                                        borderRadius: '3px'
                                    }}></div>
                                    <span style={{ fontSize: '10px' }}>Total kWh</span>
                                </div>
                            </div>
                            <h1 style={{ fontSize: '12px', textAlign: 'center' }}>Total Energy</h1>
                            <ResponsiveContainer width="100%" height={200}>
                                <BarChart data={chartDataRecharts} syncId={syncId} margin={margin}>
                                    <CartesianGrid strokeDasharray="3 3" stroke="#f9f0f3" />
                                    <XAxis {...xAxisProps} />
                                    <YAxis
                                        {...yAxisProps}
                                        label={{
                                            value: 'kWh',
                                            angle: -90,
                                            position: 'insideLeft',
                                            style: {
                                                fontSize: '12px',
                                                textAnchor: 'middle',
                                                fill: '#000000',
                                                fontWeight: 'bold'
                                            }
                                        }}
                                    />
                                    <Tooltip {...tooltipProps} />
                                    {visibleSeries.kWh && (
                                                <Bar
                                                    dataKey="kWh"
                                                    fill="#6eff54"
                                                    name="kWh"
                                                    stroke="#6eff54"
                                                    strokeWidth={1}
                                                />
                                            )}
                                    {machineConfig?.diesel && visibleSeries.calculated_diesel_kwh && (
                                        <Bar
                                            dataKey="calculated_diesel_kwh"
                                            fill="#FFA500"
                                            name="Diesel kWh"
                                        />
                                    )}
                                    {machineConfig?.lpg && visibleSeries.calculated_lpg_kwh && (
                                        <Bar
                                            dataKey="calculated_lpg_kwh"
                                            fill="#00ffea"
                                            name="LPG kWh"
                                        />
                                    )}
                                    {visibleSeries.calculated_total_kwh && (
                                        <Bar
                                            dataKey="calculated_total_kwh"
                                            fill="#4169E1"
                                            name="Total kWh"
                                        />
                                    )}
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                        <div style={{ width: '100%', marginTop: '20px', display: 'flex', flexDirection: 'row' }}>


                            <div style={{ width: '100%', marginTop: '20px', display: 'flex', flexDirection: 'column' }}>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    marginBottom: '10px',
                                    flexWrap: 'wrap',
                                    gap: '20px'
                                }}>
                                    {/* First column - kWh and Cost */}
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                cursor: 'pointer',
                                                opacity: visibleSeries.kWh ? 1 : 0.5
                                            }}
                                            onClick={() => toggleSeries('kWh')}
                                        >
                                            <div style={{
                                                width: '10px',
                                                height: '10px',
                                                backgroundColor: '#6eff54',
                                                marginRight: '5px',
                                                borderRadius: '3px'
                                            }}></div>
                                            <span style={{ fontSize: '10px' }}>kWh</span>
                                        </div>
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                cursor: 'pointer',
                                                opacity: visibleSeries.cost ? 1 : 0.5
                                            }}
                                            onClick={() => toggleSeries('cost')}
                                        >
                                            <div style={{
                                                width: '10px',
                                                height: '10px',
                                                backgroundColor: '#86d6fe',
                                                marginRight: '5px',
                                                borderRadius: '3px'
                                            }}></div>
                                            <span style={{ fontSize: '10px' }}>Cost</span>
                                        </div>
                                    </div>

                                    {/* Subsequent columns - Product groups */}
                                    {products.map((product, index) => {
                                        const productKey = product.product_name.toLowerCase();
                                        return (
                                            <div key={`product-group-${index}`} style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>

                                                {/* EnPI line */}
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        cursor: 'pointer',
                                                        opacity: visibleSeries[`kwh_per_${productKey}`] ? 1 : 0.5
                                                    }}
                                                    onClick={() => toggleSeries(`kwh_per_${productKey}`)}
                                                >
                                                    <div style={{
                                                        width: '10px',
                                                        height: '10px',
                                                        backgroundColor: getProductColors(`enpi_${productKey}`),
                                                        marginRight: '5px',
                                                        borderRadius: '3px'
                                                    }}></div>
                                                    <span style={{ fontSize: '10px' }}>EnPI {product.product_name}</span>
                                                </div>
                                                {/* Product line */}
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        cursor: 'pointer',
                                                        opacity: visibleSeries[productKey] ? 1 : 0.5
                                                    }}
                                                    onClick={() => toggleSeries(productKey)}
                                                >
                                                    <div style={{
                                                        width: '10px',
                                                        height: '10px',
                                                        backgroundColor: getProductColors(productKey),
                                                        marginRight: '5px',
                                                        borderRadius: '3px'
                                                    }}></div>
                                                    <span style={{ fontSize: '10px' }}>{product.product_name}</span>
                                                </div>


                                                {/* Target line */}
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        cursor: 'pointer',
                                                        opacity: visibleSeries[`target_${productKey}`] ? 1 : 0.5
                                                    }}
                                                    onClick={() => toggleSeries(`target_${productKey}`)}
                                                >
                                                    <div style={{
                                                        width: '10px',
                                                        height: '10px',
                                                        backgroundColor: getTargetColor(),
                                                        marginRight: '5px',
                                                        borderRadius: '3px'
                                                    }}></div>
                                                    <span style={{ fontSize: '10px' }}>Target {product.product_name}</span>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>

                                <div style={{ width: '100%', marginTop: '20px' }}>
                                    <h1 style={{ fontSize: '12px' }}>Daily EnPI</h1>
                                    <ResponsiveContainer width="100%" height={200}>
                                        <ComposedChart data={chartDataRecharts} syncId={syncId} margin={margin}>
                                            <CartesianGrid strokeDasharray="3 3" stroke="#f9f0f3" />
                                            <XAxis {...xAxisProps} />
                                            <YAxis
                                                {...yAxisProps}
                                                label={{
                                                    value: 'EnPI vs Target',
                                                    angle: -90,
                                                    position: 'insideLeft',
                                                    style: {
                                                        fontSize: '12px',
                                                        textAnchor: 'middle',
                                                        fill: '#000000',
                                                        fontWeight: 'bold'
                                                    }
                                                }}
                                            />
                                            <Tooltip {...tooltipProps} />
                                            {products.map(product => {
                                                const productKey = product.product_name.toLowerCase();
                                                const energyKey = `kwh_per_${productKey}`;

                                                return (
                                                    visibleSeries[energyKey] && (
                                                        <Bar
                                                            key={`bar-enpi-${productKey}`}
                                                            dataKey={energyKey}
                                                            fill={getProductColors(`enpi_${productKey}`)}
                                                            name={`EnPI ${product.product_name}`}
                                                            opacity={1}
                                                        />
                                                    )
                                                );
                                            })}
                                            {products.map(product => {
                                                const productKey = product.product_name.toLowerCase();
                                                const targetKey = `target_${productKey}`;
                                                const targetColor = getTargetColor();
                                                const hasTarget = machineTargets[product.product_name] !== undefined;

                                                return (
                                                    hasTarget && visibleSeries[targetKey] && (
                                                        <Line
                                                            key={`line-target-${productKey}`}
                                                            type="linear"
                                                            dataKey={targetKey}
                                                            stroke={targetColor}
                                                            strokeWidth={2}
                                                            name={`Target ${product.product_name}`}
                                                            dot={false}
                                                        />
                                                    )
                                                );
                                            })}
                                        </ComposedChart>
                                    </ResponsiveContainer>

                                    <h1 style={{ fontSize: '12px' }}>Energy vs Cost</h1>
                                    <ResponsiveContainer width="100%" height={200}>
                                        <BarChart data={chartDataRecharts} syncId={syncId} margin={margin}>
                                            <CartesianGrid strokeDasharray="3 3" stroke="#f9f0f3" />
                                            <XAxis {...xAxisProps} />
                                            <YAxis
                                                {...yAxisProps}
                                                label={{
                                                    value: 'kWh vs Cost',
                                                    angle: -90,
                                                    position: 'insideLeft',
                                                    style: {
                                                        fontSize: '12px',
                                                        textAnchor: 'middle',
                                                        fill: '#000000',
                                                        fontWeight: 'bold'
                                                    }
                                                }}
                                            />
                                            <Tooltip {...tooltipProps} />
                                            {visibleSeries.kWh && (
                                                <Bar
                                                    dataKey="kWh"
                                                    fill="#6eff54"
                                                    name="kWh"
                                                    stroke="#6eff54"
                                                    strokeWidth={1}
                                                />
                                            )}
                                            {visibleSeries.cost && (
                                                <Bar
                                                    dataKey="cost"
                                                    fill="#86d6fe"
                                                    name="Cost"
                                                    stroke="#86d6fe"
                                                    strokeWidth={1}
                                                />
                                            )}
                                        </BarChart>
                                    </ResponsiveContainer>

                                    <h1 style={{ fontSize: '12px' }}>Daily Production</h1>
                                    <ResponsiveContainer width="100%" height={300}>
                                        <BarChart data={chartDataRecharts} syncId={syncId} margin={margin}>
                                            <CartesianGrid strokeDasharray="3 3" stroke="#f9f0f3" />
                                            <XAxis {...xAxisProps} />
                                            <YAxis
                                                {...yAxisProps}
                                                label={{
                                                    value: getCommonUnit(products),
                                                    angle: -90,
                                                    position: 'insideLeft',
                                                    style: {
                                                        fontSize: '12px',
                                                        textAnchor: 'middle',
                                                        fill: '#000000',
                                                        fontWeight: 'bold'
                                                    }
                                                }}
                                            />
                                            <Tooltip {...tooltipProps} />
                                            {products.map(product => {
                                                const productKey = product.product_name.toLowerCase();
                                                const productColor = getProductColors(productKey);
                                                return (
                                                    visibleSeries[productKey] && (
                                                        <Bar
                                                            key={`bar-${productKey}`}
                                                            dataKey={productKey}
                                                            fill={productColor}
                                                            name={product.product_name}
                                                            opacity={1}
                                                        />
                                                    )
                                                );
                                            })}
                                        </BarChart>
                                    </ResponsiveContainer>
                                </div>
                            </div>
                            {machineConfig?.diesel && (
                                <div style={{ width: '100%', marginTop: '20px', display: 'flex', flexDirection: 'column' }}>
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        marginBottom: '10px',
                                        flexWrap: 'wrap',
                                        gap: '20px'
                                    }}>
                                        {/* First column - Diesel only */}
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    cursor: 'pointer',
                                                    opacity: visibleSeries.diesel ? 1 : 0.5
                                                }}
                                                onClick={() => toggleSeries('diesel')}
                                            >
                                                <div style={{
                                                    width: '10px',
                                                    height: '10px',
                                                    backgroundColor: stringToColors('diesel'),
                                                    marginRight: '5px',
                                                    borderRadius: '3px'
                                                }}></div>
                                                <span style={{ fontSize: '10px' }}>Diesel</span>
                                            </div>
                                        </div>

                                        {/* Product columns - Each product gets its own column with related metrics */}
                                        {products.map((product, index) => {
                                            const productKey = product.product_name.toLowerCase();
                                            return (
                                                <div key={`product-group-${index}`} style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            cursor: 'pointer',
                                                            opacity: visibleSeries[`diesel_per_${productKey}`] ? 1 : 0.5
                                                        }}
                                                        onClick={() => toggleSeries(`diesel_per_${productKey}`)}
                                                    >
                                                        <div style={{
                                                            width: '10px',
                                                            height: '10px',
                                                            backgroundColor: stringToColors(`diesel_per_${productKey}`),
                                                            marginRight: '5px',
                                                            borderRadius: '3px'
                                                        }}></div>
                                                        <span style={{ fontSize: '10px' }}>Diesel {product.product_name}</span>
                                                    </div>
                                                    
                                                    {/* Product line */}
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            cursor: 'pointer',
                                                            opacity: visibleSeries[productKey] ? 1 : 0.5
                                                        }}
                                                        onClick={() => toggleSeries(productKey)}
                                                    >
                                                        <div style={{
                                                            width: '10px',
                                                            height: '10px',
                                                            backgroundColor: getProductColors(productKey),
                                                            marginRight: '5px',
                                                            borderRadius: '3px'
                                                        }}></div>
                                                        <span style={{ fontSize: '10px' }}>{product.product_name}</span>
                                                    </div>

                                                    {/* Diesel per product */}
                        

                                                    {/* Diesel target */}
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            cursor: 'pointer',
                                                            opacity: visibleSeries[`diesel_target`] ? 1 : 0.5
                                                        }}
                                                        onClick={() => toggleSeries(`diesel_target`)}
                                                    >
                                                        <div style={{
                                                            width: '10px',
                                                            height: '10px',
                                                            backgroundColor: getTargetColor(),
                                                            marginRight: '5px',
                                                            borderRadius: '3px'
                                                        }}></div>
                                                        <span style={{ fontSize: '10px' }}>Diesel {product.product_name} Target</span>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>

                                    <div style={{ width: '100%', marginTop: '20px' }}>
                                        <h1 style={{ fontSize: '12px' }}>Daily Diesel EnPI</h1>
                                        <ResponsiveContainer width="100%" height={200}>
                                            <ComposedChart data={chartDataRecharts} syncId={syncId} margin={margin}>
                                                <CartesianGrid strokeDasharray="3 3" stroke="#f9f0f3" />
                                                <XAxis {...xAxisProps} />
                                                <YAxis
                                                    {...yAxisProps}
                                                    label={{
                                                        value: 'Diesel EnPI vs Target',
                                                        angle: -90,
                                                        position: 'insideLeft',
                                                        style: {
                                                            fontSize: '12px',
                                                            textAnchor: 'middle',
                                                            fill: '#000000',
                                                            fontWeight: 'bold'
                                                        }
                                                    }}
                                                />
                                                <Tooltip {...tooltipProps} />
                                                {products.map(product => {
                                                    const productKey = product.product_name.toLowerCase().replace(/\s+/g, '_');
                                                    return (
                                                        visibleSeries[`diesel_per_${productKey}`] && (
                                                            <Bar
                                                                key={`diesel-per-${productKey}`}
                                                                dataKey={`diesel_per_${productKey}`}
                                                                fill={stringToColors(`diesel_per_${productKey}`)}
                                                                name={`Diesel ${product.product_name}`}
                                                                opacity={1}
                                                            />
                                                        )
                                                    );
                                                })}
                                                {visibleSeries.diesel_target && (
                                                    <Line
                                                        type="linear"
                                                        dataKey="diesel_target"
                                                        stroke={getTargetColor()}
                                                        strokeWidth={2}
                                                        name="Diesel Target"
                                                        dot={false}
                                                    />
                                                )}
                                            </ComposedChart>
                                        </ResponsiveContainer>

                                        <h1 style={{ fontSize: '12px' }}>Daily Diesel Consumption</h1>
                                        <ResponsiveContainer width="100%" height={200}>
                                            <BarChart data={chartDataRecharts} syncId={syncId} margin={margin}>
                                                <CartesianGrid strokeDasharray="3 3" stroke="#f9f0f3" />
                                                <XAxis {...xAxisProps} />
                                                <YAxis
                                                    {...yAxisProps}
                                                    label={{
                                                        value: 'Diesel (L)',
                                                        angle: -90,
                                                        position: 'insideLeft',
                                                        style: {
                                                            fontSize: '12px',
                                                            textAnchor: 'middle',
                                                            fill: '#000000',
                                                            fontWeight: 'bold'
                                                        }
                                                    }}
                                                />
                                                <Tooltip {...tooltipProps} />
                                                {visibleSeries.diesel && (
                                                    <Bar
                                                        dataKey="diesel"
                                                        fill={stringToColors('diesel')}
                                                        name="Diesel"
                                                    />
                                                )}
                                            </BarChart>
                                        </ResponsiveContainer>

                                        <h1 style={{ fontSize: '12px' }}>Daily Production</h1>
                                        <ResponsiveContainer width="100%" height={300}>
                                            <BarChart data={chartDataRecharts} syncId={syncId} margin={margin}>
                                                <CartesianGrid strokeDasharray="3 3" stroke="#f9f0f3" />
                                                <XAxis {...xAxisProps} />
                                                <YAxis
                                                    {...yAxisProps}
                                                    label={{
                                                        value: getCommonUnit(products),
                                                        angle: -90,
                                                        position: 'insideLeft',
                                                        style: {
                                                            fontSize: '12px',
                                                            textAnchor: 'middle',
                                                            fill: '#000000',
                                                            fontWeight: 'bold'
                                                        }
                                                    }}
                                                />
                                                <Tooltip {...tooltipProps} />
                                                {products.map(product => {
                                                    const productKey = product.product_name.toLowerCase();
                                                    const productColor = getProductColors(productKey);
                                                    return (
                                                        visibleSeries[productKey] && (
                                                            <Bar
                                                                key={`bar-${productKey}`}
                                                                dataKey={productKey}
                                                                fill={productColor}
                                                                name={product.product_name}
                                                                opacity={1}
                                                            />
                                                        )
                                                    );
                                                })}
                                            </BarChart>
                                        </ResponsiveContainer>
                                    </div>
                                </div>
                            )}

                            {/* LPG Charts */}
                            {machineConfig?.lpg && (
                                <div style={{ width: '100%', marginTop: '20px', display: 'flex', flexDirection: 'column' }}>
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        marginBottom: '10px',
                                        flexWrap: 'wrap',
                                        gap: '20px'
                                    }}>
                                        {/* First column - LPG only */}
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    cursor: 'pointer',
                                                    opacity: visibleSeries.lpg ? 1 : 0.5
                                                }}
                                                onClick={() => toggleSeries('lpg')}
                                            >
                                                <div style={{
                                                    width: '10px',
                                                    height: '10px',
                                                    backgroundColor: stringToColors('lpg'),
                                                    marginRight: '5px',
                                                    borderRadius: '3px'
                                                }}></div>
                                                <span style={{ fontSize: '10px' }}>LPG</span>
                                            </div>
                                        </div>

                                        {/* Product columns - Each product gets its own column with related metrics */}
                                        {products.map((product, index) => {
                                            const productKey = product.product_name.toLowerCase();
                                            return (
                                                <div key={`product-group-${index}`} style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                                    {/* LPG per product */}
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            cursor: 'pointer',
                                                            opacity: visibleSeries[`lpg_per_${productKey}`] ? 1 : 0.5
                                                        }}
                                                        onClick={() => toggleSeries(`lpg_per_${productKey}`)}
                                                    >
                                                        <div style={{
                                                            width: '10px',
                                                            height: '10px',
                                                            backgroundColor: stringToColors(`lpg_per_${productKey}`),
                                                            marginRight: '5px',
                                                            borderRadius: '3px'
                                                        }}></div>
                                                        <span style={{ fontSize: '10px' }}>LPG per {product.product_name}</span>
                                                    </div>
                                                    
                                                    {/* Product line */}
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            cursor: 'pointer',
                                                            opacity: visibleSeries[productKey] ? 1 : 0.5
                                                        }}
                                                        onClick={() => toggleSeries(productKey)}
                                                    >
                                                        <div style={{
                                                            width: '10px',
                                                            height: '10px',
                                                            backgroundColor: getProductColors(productKey),
                                                            marginRight: '5px',
                                                            borderRadius: '3px'
                                                        }}></div>
                                                        <span style={{ fontSize: '10px' }}>{product.product_name}</span>
                                                    </div>

                                                    

                                                    {/* LPG target */}
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            cursor: 'pointer',
                                                            opacity: visibleSeries.lpg_target ? 1 : 0.5
                                                        }}
                                                        onClick={() => toggleSeries('lpg_target')}
                                                    >
                                                        <div style={{
                                                            width: '10px',
                                                            height: '10px',
                                                            backgroundColor: getTargetColor(),
                                                            marginRight: '5px',
                                                            borderRadius: '3px'
                                                        }}></div>
                                                        <span style={{ fontSize: '10px' }}>LPG {product.product_name} Target</span>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>

                                    <div style={{ width: '100%', marginTop: '20px' }}>
                                        <h1 style={{ fontSize: '12px' }}>Daily LPG EnPI</h1>
                                        <ResponsiveContainer width="100%" height={200}>
                                            <ComposedChart data={chartDataRecharts} syncId={syncId} margin={margin}>
                                                <CartesianGrid strokeDasharray="3 3" stroke="#f9f0f3" />
                                                <XAxis {...xAxisProps} />
                                                <YAxis
                                                    {...yAxisProps}
                                                    label={{
                                                        value: 'LPG EnPI vs Target',
                                                        angle: -90,
                                                        position: 'insideLeft',
                                                        style: {
                                                            fontSize: '12px',
                                                            textAnchor: 'middle',
                                                            fill: '#000000',
                                                            fontWeight: 'bold'
                                                        }
                                                    }}
                                                />
                                                <Tooltip {...tooltipProps} />
                                                {products.map(product => {
                                                    const productKey = product.product_name.toLowerCase();
                                                    return (
                                                        visibleSeries[`lpg_per_${productKey}`] && (
                                                            <Bar
                                                                key={`lpg-per-${productKey}`}
                                                                dataKey={`lpg_per_${productKey}`}
                                                                fill={stringToColors(`lpg_per_${productKey}`)}
                                                                name={`LPG ${product.product_name}`}
                                                                opacity={1}
                                                            />
                                                        )
                                                    );
                                                })}
                                                {visibleSeries.lpg_target && (
                                                    <Line
                                                        type="linear"
                                                        dataKey="lpg_target"
                                                        stroke={getTargetColor()}
                                                        strokeWidth={2}
                                                        name="LPG Target"
                                                        dot={false}
                                                    />
                                                )}
                                            </ComposedChart>
                                        </ResponsiveContainer>

                                        <h1 style={{ fontSize: '12px' }}>Daily LPG Consumption</h1>
                                        <ResponsiveContainer width="100%" height={200}>
                                            <BarChart data={chartDataRecharts} syncId={syncId} margin={margin}>
                                                <CartesianGrid strokeDasharray="3 3" stroke="#f9f0f3" />
                                                <XAxis {...xAxisProps} />
                                                <YAxis
                                                    {...yAxisProps}
                                                    label={{
                                                        value: 'LPG (kg)',
                                                        angle: -90,
                                                        position: 'insideLeft',
                                                        style: {
                                                            fontSize: '12px',
                                                            textAnchor: 'middle',
                                                            fill: '#000000',
                                                            fontWeight: 'bold'
                                                        }
                                                    }}
                                                />
                                                <Tooltip {...tooltipProps} />
                                                {visibleSeries.lpg && (
                                                    <Bar
                                                        dataKey="lpg"
                                                        fill={stringToColors('lpg')}
                                                        name="LPG"
                                                    />
                                                )}
                                            </BarChart>
                                        </ResponsiveContainer>

                                        <h1 style={{ fontSize: '12px' }}>Daily Production</h1>
                                        <ResponsiveContainer width="100%" height={300}>
                                            <BarChart data={chartDataRecharts} syncId={syncId} margin={margin}>
                                                <CartesianGrid strokeDasharray="3 3" stroke="#f9f0f3" />
                                                <XAxis {...xAxisProps} />
                                                <YAxis
                                                    {...yAxisProps}
                                                    label={{
                                                        value: getCommonUnit(products),
                                                        angle: -90,
                                                        position: 'insideLeft',
                                                        style: {
                                                            fontSize: '12px',
                                                            textAnchor: 'middle',
                                                            fill: '#000000',
                                                            fontWeight: 'bold'
                                                        }
                                                    }}
                                                />
                                                <Tooltip {...tooltipProps} />
                                                {products.map(product => {
                                                    const productKey = product.product_name.toLowerCase();
                                                    const productColor = getProductColors(productKey);
                                                    return (
                                                        visibleSeries[productKey] && (
                                                            <Bar
                                                                key={`bar-${productKey}`}
                                                                dataKey={productKey}
                                                                fill={productColor}
                                                                name={product.product_name}
                                                                opacity={1}
                                                            />
                                                        )
                                                    );
                                                })}
                                            </BarChart>
                                        </ResponsiveContainer>
                                    </div>
                                </div>
                            )}

                        </div>
                    </div>
                </div>




                <div className="charts-container" style={{ marginTop: '20px', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <div
                        className="container-4"
                        style={{
                            border: '1px solid #ccc',
                            borderRadius: '10px',
                            padding: '20px',
                            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                            backgroundColor: '#f0fbff',
                            marginTop: '20px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '100%',
                        }}
                    >
                        <h4>Monthly Production</h4>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                marginBottom: "30px",
                            }}
                        >
                            <label
                                style={{
                                    fontSize: "14px",
                                    color: "#333",
                                    fontWeight: "bold",
                                    marginRight: "10px",
                                }}
                            >
                                Year:
                            </label>
                            <select
                                value={selectedNewYear}
                                onChange={handleNewYearChange}
                                style={{
                                    padding: "5px",
                                    borderRadius: "5px",
                                    border: "1px solid #ccc",
                                }}
                            >
                                {Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - i).map(year => (
                                    <option key={year} value={year}>
                                        {year}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div style={{ width: '100%', marginTop: '20px' }}>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'center',
                                marginBottom: '10px',
                                flexWrap: 'wrap',
                                gap: '20px'
                            }}>
                                <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                cursor: 'pointer',
                                                opacity: monthSeries.kWh ? 1 : 0.5
                                            }}
                                            onClick={() => toggleMonthSeries('kWh')}
                                        >
                                            <div style={{
                                                width: '10px',
                                                height: '10px',
                                                backgroundColor: '#6eff54',
                                                marginRight: '5px',
                                                borderRadius: '3px'
                                            }}></div>
                                            <span style={{ fontSize: '10px' }}>kWh</span>
                                        </div>
                                    {machineConfig?.diesel && (
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            cursor: 'pointer',
                                            opacity: monthSeries.calculated_diesel_kwh ? 1 : 0.5
                                        }}
                                        onClick={() => toggleMonthSeries('calculated_diesel_kwh')}
                                    >
                                        <div style={{
                                            width: '10px',
                                            height: '10px',
                                            backgroundColor: '#FFA500',
                                            marginRight: '5px',
                                            borderRadius: '3px'
                                        }}></div>
                                        <span style={{ fontSize: '10px' }}>Diesel kWh</span>
                                    </div>
                                    )}
                                    {machineConfig?.lpg && (
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            cursor: 'pointer',
                                            opacity: monthSeries.calculated_lpg_kwh ? 1 : 0.5
                                        }}
                                        onClick={() => toggleMonthSeries('calculated_lpg_kwh')}
                                    >
                                        <div style={{
                                            width: '10px',
                                            height: '10px',
                                            backgroundColor: '#00ffea',
                                            marginRight: '5px',
                                            borderRadius: '3px'
                                        }}></div>
                                        <span style={{ fontSize: '10px' }}>LPG kWh</span>
                                    </div>
                                    )}
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            cursor: 'pointer',
                                            opacity: monthSeries.calculated_total_kwh ? 1 : 0.5
                                        }}
                                        onClick={() => toggleMonthSeries('calculated_total_kwh')}
                                    >
                                        <div style={{
                                            width: '10px',
                                            height: '10px',
                                            backgroundColor: '#4169E1',
                                            marginRight: '5px',
                                            borderRadius: '3px'
                                        }}></div>
                                        <span style={{ fontSize: '10px' }}>Total kWh</span>
                                    </div>
                            </div>
                            <h1 style={{ fontSize: '12px', textAlign: 'center' }}>Total Energy</h1>
                            <ResponsiveContainer width="100%" height={200}>
                                <BarChart data={chartDataRechartss} syncId={syncIds} margin={margins}>
                                    <CartesianGrid strokeDasharray="3 3" stroke="#f0fbff" />
                                    <XAxis {...xAxisPropss} />
                                    <YAxis
                                        {...yAxisPropss}
                                        label={{
                                            value: "kWh",
                                            angle: -90,
                                            position: 'insideLeft',
                                            style: { fontSize: '12px', textAnchor: 'middle', fill: '#000000', fontWeight: 'bold' }
                                        }}
                                    />
                                    <Tooltip {...tooltipPropss} />
                                    <Bar
                                                dataKey="kWh"
                                                fill="#6eff54"
                                                name="kWh"
                                                hide={!monthSeries.kWh}
                                            />
                                    {machineConfig?.diesel && (
                                    <Bar
                                        dataKey="calculated_diesel_kwh"
                                        fill="#FFA500"
                                        name="Diesel kWh"
                                        hide={!monthSeries.calculated_diesel_kwh}
                                    />
                                    )}
                                    {machineConfig?.lpg && (
                                    <Bar
                                        dataKey="calculated_lpg_kwh"
                                        fill="#00ffea"
                                        name="LPG kWh"
                                        hide={!monthSeries.calculated_lpg_kwh}
                                    />
                                    )}
                                    <Bar
                                        dataKey="calculated_total_kwh"
                                        fill="#4169E1"
                                        name="Total kWh"
                                        hide={!monthSeries.calculated_total_kwh}
                                    />
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                        <div style={{ width: '100%', marginTop: '20px', display: 'flex', flexDirection: 'row' }}>


                            <div style={{ width: '100%', marginTop: '20px', display: 'flex', flexDirection: 'column' }}>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    marginBottom: '10px',
                                    flexWrap: 'wrap',
                                    gap: '20px'
                                }}>
                                    {/* First column - kWh and Cost */}
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                cursor: 'pointer',
                                                opacity: monthSeries.kWh ? 1 : 0.5
                                            }}
                                            onClick={() => toggleMonthSeries('kWh')}
                                        >
                                            <div style={{
                                                width: '10px',
                                                height: '10px',
                                                backgroundColor: '#6eff54',
                                                marginRight: '5px',
                                                borderRadius: '3px'
                                            }}></div>
                                            <span style={{ fontSize: '10px' }}>kWh</span>
                                        </div>
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                cursor: 'pointer',
                                                opacity: monthSeries.cost ? 1 : 0.5
                                            }}
                                            onClick={() => toggleMonthSeries('cost')}
                                        >
                                            <div style={{
                                                width: '10px',
                                                height: '10px',
                                                backgroundColor: '#86d6fe',
                                                marginRight: '5px',
                                                borderRadius: '3px'
                                            }}></div>
                                            <span style={{ fontSize: '10px' }}>Cost</span>
                                        </div>
                                    </div>

                                    {/* Product columns - Each product gets its own column with related metrics */}
                                    {Object.keys(monthlyData.production).map((product, index) => (
                                        <div key={`product-col-${index}`} style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                            {/* EnPI */}
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    cursor: 'pointer',
                                                    opacity: monthSeries[`sec_${product}`] ? 1 : 0.5
                                                }}
                                                onClick={() => toggleMonthSeries(`sec_${product}`)}
                                            >
                                                <div style={{
                                                    width: '10px',
                                                    height: '10px',
                                                    backgroundColor: getProductColor(`enpi_${product}`),
                                                    marginRight: '5px',
                                                    borderRadius: '3px',
                                                    opacity: 0.6
                                                }}></div>
                                                <span style={{ fontSize: '10px' }}>EnPI {product}</span>
                                            </div>
                                            
                                            {/* Production */}
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    cursor: 'pointer',
                                                    opacity: monthSeries[`production_${product}`] ? 1 : 0.5
                                                }}
                                                onClick={() => toggleMonthSeries(`production_${product}`)}
                                            >
                                                <div style={{
                                                    width: '10px',
                                                    height: '10px',
                                                    backgroundColor: getProductColor(product),
                                                    marginRight: '5px',
                                                    borderRadius: '3px'
                                                }}></div>
                                                <span style={{ fontSize: '10px' }}>{product}</span>
                                            </div>

                                        

                                            {/* Target */}
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    cursor: 'pointer',
                                                    opacity: monthSeries[`target_${product}`] ? 1 : 0.5
                                                }}
                                                onClick={() => toggleMonthSeries(`target_${product}`)}
                                            >
                                                <div style={{
                                                    width: '10px',
                                                    height: '10px',
                                                    backgroundColor: getTargetColor(),
                                                    marginRight: '5px',
                                                    borderRadius: '3px'
                                                }}></div>
                                                <span style={{ fontSize: '10px' }}>Target {product}</span>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                <div style={{ width: '100%', marginTop: '20px' }}>
                                    <h1 style={{ fontSize: '12px' }}>Monthly EnPI</h1>
                                    <ResponsiveContainer width="100%" height={200}>
                                        <ComposedChart data={chartDataRechartss} syncId={syncIds} margin={margins}>
                                            <CartesianGrid strokeDasharray="3 3" stroke="#f0fbff" />
                                            <XAxis {...xAxisPropss} />
                                            <YAxis
                                                {...yAxisPropss}
                                                label={{
                                                    value: getYAxisLabel('enpi', products),
                                                    angle: -90,
                                                    position: 'insideLeft',
                                                    style: { fontSize: '12px', textAnchor: 'middle', fill: '#000000',fontWeight: 'bold' }
                                                }}
                                            />
                                            <Tooltip {...tooltipPropss} />
                                            {Object.keys(monthlyData.production_per_kWh).map(product => (
                                                <Bar
                                                    key={`sec_${product}`}
                                                    dataKey={`sec_${product}`}
                                                    fill={getProductColor(`enpi_${product}`)}
                                                    name={`EnPI ${product}`}
                                                    hide={!monthSeries[`sec_${product}`]}
                                                />
                                            ))}
                                            {Object.keys(machineTargets).map(product => (
                                                <Line
                                                    key={`target_${product}`}
                                                    type="linear"
                                                    dataKey={`target_${product}`}
                                                    stroke={getTargetColor()}
                                                    strokeWidth={3}
                                                    name={`Target ${product}`}
                                                    dot={false}
                                                    hide={!monthSeries[`target_${product}`]}
                                                />
                                            ))}
                                        </ComposedChart>
                                    </ResponsiveContainer>

                                    <h1 style={{ fontSize: '12px' }}>Energy vs Cost</h1>
                                    <ResponsiveContainer width="100%" height={200}>
                                        <BarChart data={chartDataRechartss} syncId={syncIds} margin={margins}>
                                            <CartesianGrid strokeDasharray="3 3" stroke="#f0fbff" />
                                            <XAxis {...xAxisPropss} />
                                            <YAxis
                                                {...yAxisPropss}
                                                label={{
                                                    value: getYAxisLabel('energy-cost', products),
                                                    angle: -90,
                                                    position: 'insideLeft',
                                                    style: { fontSize: '12px', textAnchor: 'middle', fill: '#000000', fontWeight: 'bold' }
                                                }}
                                            />
                                            <Tooltip {...tooltipPropss} />
                                            <Bar
                                                dataKey="cost"
                                                fill="#86d6fe"
                                                name="Cost"
                                                hide={!monthSeries.cost}
                                            />
                                            <Bar
                                                dataKey="kWh"
                                                fill="#6eff54"
                                                name="kWh"
                                                hide={!monthSeries.kWh}
                                            />
                                        </BarChart>
                                    </ResponsiveContainer>

                                    <h1 style={{ fontSize: '12px' }}>Monthly Production</h1>
                                    <ResponsiveContainer width="100%" height={300}>
                                        <BarChart data={chartDataRechartss} syncId={syncIds} margin={margins}>
                                            <CartesianGrid strokeDasharray="3 3" stroke="#f0fbff" />
                                            <XAxis {...xAxisPropss} />
                                            <YAxis
                                                {...yAxisPropss}
                                                label={{
                                                    value: getYAxisLabel('production', products),
                                                    angle: -90,
                                                    position: 'insideLeft',
                                                    style: { fontSize: '12px', textAnchor: 'middle', fill: '#000000', fontWeight: 'bold' }
                                                }}
                                            />
                                            <Tooltip {...tooltipPropss} />
                                            {Object.keys(monthlyData.production).map(product => (
                                                <Bar
                                                    key={`production_${product}`}
                                                    dataKey={`production_${product}`}
                                                    fill={getProductColor(product)}
                                                    name={product}
                                                    hide={!monthSeries[`production_${product}`]}
                                                />
                                            ))}
                                        </BarChart>
                                    </ResponsiveContainer>
                                </div>
                            </div>
                            {machineConfig?.diesel && (
                                <div style={{ width: '100%', marginTop: '20px', display: 'flex', flexDirection: 'column' }}>
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        marginBottom: '10px',
                                        flexWrap: 'wrap',
                                        gap: '20px'
                                    }}>
                                        {/* First column - Diesel metrics */}
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    cursor: 'pointer',
                                                    opacity: monthSeries.diesel ? 1 : 0.5
                                                }}
                                                onClick={() => toggleMonthSeries('diesel')}
                                            >
                                                <div style={{
                                                    width: '10px',
                                                    height: '10px',
                                                    backgroundColor: stringToColor('diesel'),
                                                    marginRight: '5px',
                                                    borderRadius: '3px'
                                                }}></div>
                                                <span style={{ fontSize: '10px' }}>Diesel</span>
                                            </div>
                                        </div>

                                        {/* Product columns - Each product gets its own column */}
                                        {Object.keys(monthlyData.production).map((product, index) => (
                                            <div key={`product-col-${index}`} style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                                {/* Diesel per product */}
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        cursor: 'pointer',
                                                        opacity: monthSeries[`diesel_per_${product}`] ? 1 : 0.5
                                                    }}
                                                    onClick={() => toggleMonthSeries(`diesel_per_${product}`)}
                                                >
                                                    <div style={{
                                                        width: '10px',
                                                        height: '10px',
                                                        backgroundColor: stringToColor(`diesel_per_${product}`),
                                                        marginRight: '5px',
                                                        borderRadius: '3px'
                                                    }}></div>
                                                    <span style={{ fontSize: '10px' }}>Diesel {product}</span>
                                                </div>
                                                
                                                {/* Production */}
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        cursor: 'pointer',
                                                        opacity: monthSeries[`production_${product}`] ? 1 : 0.5
                                                    }}
                                                    onClick={() => toggleMonthSeries(`production_${product}`)}
                                                >
                                                    <div style={{
                                                        width: '10px',
                                                        height: '10px',
                                                        backgroundColor: getProductColor(product),
                                                        marginRight: '5px',
                                                        borderRadius: '3px'
                                                    }}></div>
                                                    <span style={{ fontSize: '10px' }}>{product}</span>
                                                </div>

                                                

                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        cursor: 'pointer',
                                                        opacity: monthSeries.diesel_target ? 1 : 0.5
                                                    }}
                                                    onClick={() => toggleMonthSeries('diesel_target')}
                                                >
                                                    <div style={{
                                                        width: '10px',
                                                        height: '10px',
                                                        backgroundColor: getTargetColor(),
                                                        marginRight: '5px',
                                                        borderRadius: '3px'
                                                    }}></div>
                                                    <span style={{ fontSize: '10px' }}>Diesel {product} Target</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                    <div style={{ width: '100%', marginTop: '20px' }}>
                                        <h1 style={{ fontSize: '12px' }}>Monthly Diesel EnPI</h1>
                                        <ResponsiveContainer width="100%" height={200}>
                                            <ComposedChart data={chartDataRechartss} syncId={syncIds} margin={margins}>
                                                <CartesianGrid strokeDasharray="3 3" stroke="#f0fbff" />
                                                <XAxis {...xAxisPropss} />
                                                <YAxis
                                                    {...yAxisPropss}
                                                    label={{
                                                        value: getYAxisLabel('diesel-enpi', products),
                                                        angle: -90,
                                                        position: 'insideLeft',
                                                        style: { fontSize: '12px', textAnchor: 'middle' , fill: '#000000',fontWeight: 'bold'}
                                                    }}
                                                />
                                                <Tooltip {...tooltipPropss} />
                                                {Object.keys(monthlyData.production).map(product => (
                                                    monthSeries[`diesel_per_${product}`] && (
                                                        <Bar
                                                            key={`diesel-per-${product}`}
                                                            dataKey={`diesel_per_${product}`}
                                                            fill={stringToColor(`diesel_per_${product}`)}
                                                            name={`Diesel ${product}`}
                                                        />
                                                    )
                                                ))}
                                                {monthSeries.diesel_target && (
                                                    <Line
                                                        type="linear"
                                                        dataKey="diesel_target"
                                                        stroke={getTargetColor()}
                                                        strokeWidth={2}
                                                        name="Diesel Target"
                                                        dot={false}
                                                    />
                                                )}
                                            </ComposedChart>
                                        </ResponsiveContainer>

                                        <h1 style={{ fontSize: '12px' }}>Monthly Diesel Consumption</h1>
                                        <ResponsiveContainer width="100%" height={200}>
                                            <BarChart data={chartDataRechartss} syncId={syncIds} margin={margins}>
                                                <CartesianGrid strokeDasharray="3 3" stroke="#f0fbff" />
                                                <XAxis {...xAxisPropss} />
                                                <YAxis
                                                    {...yAxisPropss}
                                                    label={{
                                                        value: getYAxisLabel('diesel-consumption', products),
                                                        angle: -90,
                                                        position: 'insideLeft',
                                                        style: { fontSize: '12px', textAnchor: 'middle',fill: '#000000', fontWeight: 'bold' }
                                                    }}
                                                />
                                                <Tooltip {...tooltipPropss} />
                                                {monthSeries.diesel && (
                                                    <Bar
                                                        dataKey="diesel"
                                                        fill={stringToColor('diesel')}
                                                        name="Diesel"
                                                    />
                                                )}
                                            </BarChart>
                                        </ResponsiveContainer>

                                        <h1 style={{ fontSize: '12px' }}>Monthly Production</h1>
                                        <ResponsiveContainer width="100%" height={300}>
                                            <BarChart data={chartDataRechartss} syncId={syncIds} margin={margins}>
                                                <CartesianGrid strokeDasharray="3 3" stroke="#f0fbff" />
                                                <XAxis {...xAxisPropss} />
                                                <YAxis
                                                    {...yAxisPropss}
                                                    label={{
                                                        value: getYAxisLabel('production', products),
                                                        angle: -90,
                                                        position: 'insideLeft',
                                                        style: { fontSize: '12px', textAnchor: 'middle', fill: '#000000',fontWeight: 'bold' }
                                                    }}
                                                />
                                                <Tooltip {...tooltipPropss} />
                                                {Object.keys(monthlyData.production).map(product => (
                                                    <Bar
                                                        key={`production_${product}`}
                                                        dataKey={`production_${product}`}
                                                        fill={getProductColor(product)}
                                                        name={product}
                                                        hide={!monthSeries[`production_${product}`]}
                                                    />
                                                ))}
                                            </BarChart>
                                        </ResponsiveContainer>
                                    </div>
                                </div>
                            )}
                            {machineConfig?.lpg && (
                                <div style={{ width: '100%', marginTop: '20px', display: 'flex', flexDirection: 'column' }}>
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        marginBottom: '10px',
                                        flexWrap: 'wrap',
                                        gap: '20px'
                                    }}>
                                        {/* First column - LPG metrics */}
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    cursor: 'pointer',
                                                    opacity: monthSeries.lpg ? 1 : 0.5
                                                }}
                                                onClick={() => toggleMonthSeries('lpg')}
                                            >
                                                <div style={{
                                                    width: '10px',
                                                    height: '10px',
                                                    backgroundColor: stringToColor('lpg'),
                                                    marginRight: '5px',
                                                    borderRadius: '3px'
                                                }}></div>
                                                <span style={{ fontSize: '10px' }}>LPG</span>
                                            </div>
                                        </div>

                                        {/* Product columns - Each product gets its own column with related metrics */}
                                        {Object.keys(monthlyData.production).map((product, index) => (
                                            <div key={`product-col-${index}`} style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                                {/* LPG per product */}
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        cursor: 'pointer',
                                                        opacity: monthSeries[`lpg_per_${product}`] ? 1 : 0.5
                                                    }}
                                                    onClick={() => toggleMonthSeries(`lpg_per_${product}`)}
                                                >
                                                    <div style={{
                                                        width: '10px',
                                                        height: '10px',
                                                        backgroundColor: stringToColor(`lpg_per_${product}`),
                                                        marginRight: '5px',
                                                        borderRadius: '3px'
                                                    }}></div>
                                                    <span style={{ fontSize: '10px' }}>LPG {product}</span>
                                                </div>
                                                
                                                {/* Production */}
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        cursor: 'pointer',
                                                        opacity: monthSeries[`production_${product}`] ? 1 : 0.5
                                                    }}
                                                    onClick={() => toggleMonthSeries(`production_${product}`)}
                                                >
                                                    <div style={{
                                                        width: '10px',
                                                        height: '10px',
                                                        backgroundColor: getProductColor(product),
                                                        marginRight: '5px',
                                                        borderRadius: '3px'
                                                    }}></div>
                                                    <span style={{ fontSize: '10px' }}>{product}</span>
                                                </div>

                                                

                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        cursor: 'pointer',
                                                        opacity: monthSeries.lpg_target ? 1 : 0.5
                                                    }}
                                                    onClick={() => toggleMonthSeries('lpg_target')}
                                                >
                                                    <div style={{
                                                        width: '10px',
                                                        height: '10px',
                                                        backgroundColor: getTargetColor(),
                                                        marginRight: '5px',
                                                        borderRadius: '3px'
                                                    }}></div>
                                                    <span style={{ fontSize: '10px' }}>LPG {product} Target</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                    <div style={{ width: '100%', marginTop: '20px' }}>
                                        <h1 style={{ fontSize: '12px' }}>Monthly LPG EnPI</h1>
                                        <ResponsiveContainer width="100%" height={200}>
                                            <ComposedChart data={chartDataRechartss} syncId={syncIds} margin={margins}>
                                                <CartesianGrid strokeDasharray="3 3" stroke="#f0fbff" />
                                                <XAxis {...xAxisPropss} />
                                                <YAxis
                                                    {...yAxisPropss}
                                                    label={{
                                                        value: getYAxisLabel('lpg-enpi', products),
                                                        angle: -90,
                                                        position: 'insideLeft',
                                                        style: { fontSize: '12px', textAnchor: 'middle', fill: '#000000',fontWeight: 'bold' }
                                                    }}
                                                />
                                                <Tooltip {...tooltipPropss} />
                                                {Object.keys(monthlyData.production).map(product => (
                                                    monthSeries[`lpg_per_${product}`] && (
                                                        <Bar
                                                            key={`lpg-per-${product}`}
                                                            dataKey={`lpg_per_${product}`}
                                                            fill={stringToColor(`lpg_per_${product}`)}
                                                            name={`LPG ${product}`}
                                                        />
                                                    )
                                                ))}
                                                {monthSeries.lpg_target && (
                                                    <Line
                                                        type="linear"
                                                        dataKey="lpg_target"
                                                        stroke={getTargetColor()}
                                                        strokeWidth={2}
                                                        name="LPG Target"
                                                        dot={false}
                                                    />
                                                )}
                                            </ComposedChart>
                                        </ResponsiveContainer>

                                        <h1 style={{ fontSize: '12px' }}>Monthly LPG Consumption</h1>
                                        <ResponsiveContainer width="100%" height={200}>
                                            <BarChart data={chartDataRechartss} syncId={syncIds} margin={margins}>
                                                <CartesianGrid strokeDasharray="3 3" stroke="#f0fbff" />
                                                <XAxis {...xAxisPropss} />
                                                <YAxis
                                                    {...yAxisPropss}
                                                    label={{
                                                        value: getYAxisLabel('lpg-consumption', products),
                                                        angle: -90,
                                                        position: 'insideLeft',
                                                        style: { fontSize: '12px', textAnchor: 'middle',fill: '#000000',fontWeight: 'bold' }
                                                    }}
                                                />
                                                <Tooltip {...tooltipPropss} />
                                                {monthSeries.lpg && (
                                                    <Bar
                                                        dataKey="lpg"
                                                        fill={stringToColor('lpg')}
                                                        name="LPG"
                                                    />
                                                )}
                                            </BarChart>
                                        </ResponsiveContainer>

                                        <h1 style={{ fontSize: '12px' }}>Monthly Production</h1>
                                        <ResponsiveContainer width="100%" height={300}>
                                            <BarChart data={chartDataRechartss} syncId={syncIds} margin={margins}>
                                                <CartesianGrid strokeDasharray="3 3" stroke="#f0fbff" />
                                                <XAxis {...xAxisPropss} />
                                                <YAxis
                                                    {...yAxisPropss}
                                                    label={{
                                                        value: getYAxisLabel('production', products),
                                                        angle: -90,
                                                        position: 'insideLeft',
                                                        style: {
                                                            fontSize: '12px',
                                                            textAnchor: 'middle',
                                                            fill: '#000000',
                                                            fontWeight: 'bold'
                                                        }
                                                    }}
                                                />
                                                <Tooltip {...tooltipPropss} />
                                                {Object.keys(monthlyData.production).map(product => (
                                                    <Bar
                                                        key={`production_${product}`}
                                                        dataKey={`production_${product}`}
                                                        fill={getProductColor(product)}
                                                        name={product}
                                                        hide={!monthSeries[`production_${product}`]}
                                                    />
                                                ))}
                                            </BarChart>
                                        </ResponsiveContainer>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <div className="dashboard">
                    <div className="main-container">
                        <div className="nav-bar">
                            {tabs.map((tab) => (
                                <button
                                    key={tab}
                                    className={activeTab === tab ? "active" : ""}
                                    onClick={() => handleTabChange(tab)}
                                >
                                    {tab}
                                </button>
                            ))}
                        </div>
                        {activeTab === "Daily Report" && (
                            <div className="daily-report-production">
                                <div className="card controls-card">
                                    <input
                                        type="date"
                                        value={fromDate}
                                        onChange={(e) => setFromDate(e.target.value)}
                                        placeholder="From Date"
                                        max={getFormattedDateTime(new Date())}
                                    />
                                    <input
                                        type="date"
                                        value={toDate}
                                        onChange={(e) => setToDate(e.target.value)}
                                        placeholder="To Date"
                                        max={getFormattedDateTime(new Date())}
                                    />
                                    <button onClick={handleGetDailyReport}>Get Report</button>
                                    <button
                                        onClick={() => {
                                            const fileName = `Daily_Report_${fromDate}_to_${toDate}.xlsx`;
                                            handleExportToExcel(dailyreportData, fileName);
                                        }}
                                    >
                                        <i className="excel-icon">📊</i> Excel
                                    </button>
                                </div>
                                {dailyloading ? (
                                    <span className="spinner" />
                                ) : (
                                    <div className="table-container" style={{ overflowX: 'auto' }}>
                                        <h4 className="table-title">
                                            Daily Log View from {fromDate} to {toDate}
                                        </h4>
                                        <table style={{ minWidth: '100%' }}>
                                            <thead>
                                                <tr>
                                                    <th>Production Date</th>
                                                    <th>From Date</th>
                                                    <th>To Date</th>
                                                    <th>Total KWH</th>
                                                    <th>Total Cost</th>
                                                    {getProductionKeys().map(key => (
                                                        <th key={`prod-${key}`}>{key}</th>
                                                    ))}
                                                    {getProductionKeys().map(key => (
                                                        <th key={`target-${key}`}>Target {key}</th>
                                                    ))}
                                                    {getProductionKeys().map(key => (
                                                        <th key={`sec-${key}`}>EnPI {key}</th>
                                                    ))}
                                                    {getEnergyColumns().map(col => (
                                                        <th key={col.key}>{col.label}</th>
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {currentDailyRows.length > 0 ? (
                                                    currentDailyRows.map((row, index) => (
                                                        <tr key={index}>
                                                            <td>{row.production_date}</td>
                                                            <td>{row.from_date}</td>
                                                            <td>{row.to_date}</td>
                                                            <td>{row.totalKwh.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                                            <td>{row.totalCost.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                                            {getProductionKeys().map(key => (
                                                                <td key={`prod-val-${key}-${index}`}>
                                                                    {getProductionValue(row.production, key).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                </td>
                                                            ))}
                                                            {getProductionKeys().map(key => (
                                                                <td key={`target-val-${key}-${index}`}>
                                                                    {getProductionValue(row.target_production, key).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                </td>
                                                            ))}
                                                            {getProductionKeys().map(key => (
                                                                <td key={`sec-val-${key}-${index}`}>
                                                                    {getProductionValue(row.sec, key).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                </td>
                                                            ))}
                                                            {machineConfig.diesel && (
                                                                <>
                                                                    <td>
                                                                        {row.energy_consumption?.Diesel?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0'}
                                                                    </td>
                                                                    <td>
                                                                        {row.energy_target?.Diesel?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0'}
                                                                    </td>
                                                                    {getProductionKeys().map(key => (
                                                                        <td key={`diesel-per-${key}-${index}`}>
                                                                            {row.production_per_energy?.Diesel?.[key]?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0'}
                                                                        </td>
                                                                    ))}
                                                                </>
                                                            )}

                                                            {machineConfig.lpg && (
                                                                <>
                                                                    <td>
                                                                        {row.energy_consumption?.LPG?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0'}
                                                                    </td>
                                                                    <td>
                                                                        {row.energy_target?.LPG?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0'}
                                                                    </td>
                                                                    {getProductionKeys().map(key => (
                                                                        <td key={`lpg-per-${key}-${index}`}>
                                                                            {row.production_per_energy?.LPG?.[key]?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0'}
                                                                        </td>
                                                                    ))}
                                                                </>
                                                            )}
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan={6 + getProductionKeys().length * 3 + getEnergyColumns().length} style={{ textAlign: "center" }}>
                                                            No Data Available
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                                <div className="pagination-controls">
                                    <button
                                        disabled={currentdailyreportPage === 1 || currentDailyRows.length === 0}
                                        onClick={() => handledailyPageChange(currentdailyreportPage - 1)}
                                    >
                                        Previous
                                    </button>
                                    <span>  {currentdailyreportPage}   of   {totaldailyPages}  </span>
                                    <button
                                        disabled={currentdailyreportPage === totaldailyPages || currentDailyRows.length === 0}
                                        onClick={() => handledailyPageChange(currentdailyreportPage + 1)}
                                    >
                                        Next
                                    </button>
                                </div>
                            </div>
                        )}
                        {activeTab === "Monthly Report" && (
                            <div className="Monthly-Report">
                                <div className="card controls-card">
                                    <DatePicker
                                        selected={monthlyfromDate}
                                        onChange={handleMonthlyFromMonthChange}
                                        dateFormat="yyyy-MM"
                                        maxDate={new Date()}
                                        showMonthYearPicker
                                        placeholderText="Select From Month"
                                        className="custom-date-picker"
                                    />

                                    <DatePicker
                                        selected={monthlytoDate}
                                        onChange={handleMonthlyToMonthChange}
                                        dateFormat="yyyy-MM"
                                        maxDate={new Date()}
                                        showMonthYearPicker
                                        placeholderText="Select To Month"
                                        className="custom-date-picker"
                                    />
                                    <button onClick={handleMonthlyReport}>Get Report</button>
                                    <button
                                        onClick={() => handleMonthlyExportToExcel(monthsData, generateFilename())}
                                    >
                                        <i className="excel-icon">📊</i> Excel
                                    </button>
                                </div>
                                {monthlyloading ? (
                                    <div>
                                        <span className="spinner"></span>
                                    </div>
                                ) : (
                                    <div className="table-container" style={{ overflowX: 'auto' }}>
                                        <h4 className="table-title">Monthly Report from {monthlyfromDate ? monthlyfromDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long' }) : "Selected from Month"} to {monthlytoDate ? monthlytoDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long' }) : "Selected to Month"}</h4>
                                        <table style={{ minWidth: '100%' }}>
                                            <thead>
                                                <tr>
                                                    <th>S.No</th>
                                                    <th>Month</th>
                                                    {filteredColumns.map((column, index) => (
                                                        <th key={index}>{column.name}</th>
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {monthsData.months && monthsData.months.length > 0 ? (
                                                    currentMonthlyMonths.map((month, monthIndex) => {
                                                        const absoluteIndex = indexOfmonthlyFirstRow + monthIndex;
                                                        return (
                                                            <tr key={month}>
                                                                <td>{absoluteIndex + 1}</td>
                                                                <td>{month}</td>
                                                                {filteredColumns.map((column, colIndex) => (
                                                                    <td key={colIndex}>
                                                                        {column.data[absoluteIndex].toLocaleString(undefined, {
                                                                            minimumFractionDigits: 2,
                                                                            maximumFractionDigits: 2
                                                                        })}
                                                                    </td>
                                                                ))}
                                                            </tr>
                                                        );
                                                    })
                                                ) : (
                                                    <tr>
                                                        <td colSpan={filteredColumns.length + 2} style={{ textAlign: "center" }}>
                                                            No data available
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                                <div className="pagination-controls">
                                    <button
                                        disabled={currentmonthlyreportPage === 1 || monthsData.months.length === 0}
                                        onClick={() => handlemonthlyPageChange(currentmonthlyreportPage - 1)}
                                    >
                                        Previous
                                    </button>
                                    <span>  {currentmonthlyreportPage}   of   {totalmonthlyPages}  </span>
                                    <button
                                        disabled={currentmonthlyreportPage === totalmonthlyPages || monthsData.months.length === 0}
                                        onClick={() => handlemonthlyPageChange(currentmonthlyreportPage + 1)}
                                    >
                                        Next
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProductionSub;
